import * as CNCaptcha from '@byted/sec_sdk_build/captcha';
import * as SGCaptcha from '@byted/sec_sdk_build/captcha/sg';
import * as VACaptcha from '@byted/sec_sdk_build/captcha/va';
import * as INCaptcha from '@byted/sec_sdk_build/captcha/in';
import axios from 'axios';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var URL_PREFIX = {
  WEB: '/passport/web',
  APP: '/passport/mobile',
  WEB_AFF: '/passport/aff/web'
};
var WEB_URL = {
  SEND_MOBILE_CODE: URL_PREFIX.WEB + "/send_code/",
  SEND_EMAIL_CODE: URL_PREFIX.WEB + "/email/send_code/",
  VERIFY_MOBILE_CODE: URL_PREFIX.WEB + "/validate_code/",
  VERIFY_EMAIL_CODE: URL_PREFIX.WEB + "/email/verify/",
  CHECK_MOBILE_CODE: URL_PREFIX.WEB + "/mobile/check_code/",
  CHECK_EMAIL_CODE: URL_PREFIX.WEB + "/email/check_code/",
  // login & register
  SMS_LOGIN: URL_PREFIX.WEB + "/sms_login/",
  SMS_LOGIN_ONLY: URL_PREFIX.WEB + "/sms_login_only/",
  SMS_LOGIN_CONTINUE: URL_PREFIX.WEB + "/sms_login_continue/",
  EMAIL_LOGIN: URL_PREFIX.WEB + "/email/login/",
  EMAIL_REGISTER_LOGIN: URL_PREFIX.WEB + "/email/register_verify_login/",
  EMAIL_REGISTER: URL_PREFIX.WEB + "/email/register_verify/",
  PWD_LOGIN: URL_PREFIX.WEB + "/user/login/",
  AUTH_LOGIN: URL_PREFIX.WEB + "/auth/login/",
  AUTH_LOGIN_ONLY: URL_PREFIX.WEB + "/auth/login_only/",
  AUTH_BIND_ONLY: URL_PREFIX.WEB + "/auth/bind_login/",
  MOBILE_BIND_ONLY: URL_PREFIX.WEB + "/mobile/bind_login/",
  MOBILE_EMAIL_REGISTER: URL_PREFIX.WEB + "/mobile_email_register/",
  MOBILE_REGISTER: '/passport/mobile/register/',
  MOBILE_OAUTH: '/passport/auth/show_oauth_mobile/',
  LOGOUT: URL_PREFIX.WEB + "/logout/",
  CHECK_LOGIN: "/passport/account/info/v2/",
  BIND_WITH_MOBILE_LOGIN: URL_PREFIX.WEB + "/auth/bind_with_mobile_login/",
  GET_QRCODE: URL_PREFIX.WEB + "/get_qrcode/",
  CHECK_QRCONNECT: URL_PREFIX.WEB + "/check_qrconnect/",
  SCAN_QRCODE: URL_PREFIX.WEB + "/scan_qrcode/",
  CONFIRM_QRCODE: URL_PREFIX.WEB + "/confirm_qrcode/",
  THIRD_AUTH: URL_PREFIX.WEB + "/web_login/",
  // bind
  MOBILE_BIND: URL_PREFIX.WEB + "/mobile/bind/",
  EMAIL_BIND: URL_PREFIX.WEB + "/email/bind/",
  AUTH_BIND: URL_PREFIX.WEB + "/auth/bind/",
  AUTH_UNBIND: URL_PREFIX.WEB + "/auth/unbind/",
  AUTH_SWITCH_BIND: URL_PREFIX.WEB + "/auth/switch_bind/",
  // rebind
  MOBILE_REBIND: URL_PREFIX.WEB + "/mobile/change/",
  EMAIL_REBIND: URL_PREFIX.WEB + "/email/change/",
  // forget password
  RESET_PWD_BY_MOBILE: URL_PREFIX.WEB + "/password/reset/",
  RESET_PWD_BY_EMAIL: URL_PREFIX.WEB + "/email/password/reset/",
  RESET_PWD_BY_MOBILE_TICKET: URL_PREFIX.WEB + "/password/reset_by_ticket/",
  RESET_PWD_BY_EMAIL_TICKET: URL_PREFIX.WEB + "/password/reset_by_email_ticket/",
  // password
  PWD_CHANGE_BY_MOBILE: URL_PREFIX.WEB + "/password/change/",
  PWD_UPDATE: URL_PREFIX.WEB + "/password/update/",
  PWD_CHANGE_BY_EMAIL: URL_PREFIX.WEB + "/email/change_password/",
  PWD_SET: URL_PREFIX.WEB + "/password/set/",
  PWD_HAS_SET: "/passport/password/has_set/",
  // verify
  ACCOUNT_VERIFY: URL_PREFIX.WEB + "/account/verify/",
  AUTH_VERIFY: URL_PREFIX.WEB + "/auth/verify/",
  // cancel
  CANCEL_VERIFY_WAY: '/passport/auth/cancel_verify_way/',
  CANCEL_CHECK: URL_PREFIX.WEB + "/cancel/check/",
  CANCEL_CONFIRM: URL_PREFIX.WEB + "/cancel/confirm/",
  // extra
  CHECK_MOBILE_REGISTER: URL_PREFIX.WEB + "/user/check_mobile_registered/",
  CHECK_EMAIL_REGISTER: URL_PREFIX.WEB + "/user/check_email_registered/",
  // open
  GET_OPEN_AUTH_INFO: '/passport/open/auth_info/v2/',
  OPEN_SEND_CODE: '/oauth/send_code/',
  OPEN_SMS_AUTH: '/passport/open/web/sms/auth/',
  OPEN_ACCOUNT_AUTH: '/passport/open/web/account/auth/',
  // account
  ACCOUNT_INFO: URL_PREFIX.WEB + "/account/info/"
};
var WEB_AFF_URL = {
  SEND_MOBILE_CODE: URL_PREFIX.WEB_AFF + "/mobile/send_code/",
  SEND_EMAIL_CODE: URL_PREFIX.WEB_AFF + "/email/send_code/",
  VERIFY_MOBILE_CODE: URL_PREFIX.WEB_AFF + "/mobile/validate_code/",
  VERIFY_EMAIL_CODE: URL_PREFIX.WEB_AFF + "/email/verify/",
  CHECK_MOBILE_CODE: URL_PREFIX.WEB_AFF + "/mobile/check_code/",
  CHECK_EMAIL_CODE: URL_PREFIX.WEB_AFF + "/email/check_code/",
  // login
  SMS_LOGIN: URL_PREFIX.WEB_AFF + "/mobile/sms_login/",
  EMAIL_LOGIN: URL_PREFIX.WEB_AFF + "/email/code_login/",
  PWD_LOGIN: URL_PREFIX.WEB_AFF + "/user/login/",
  OAUTH_LOGIN_CALL: URL_PREFIX.WEB_AFF + "/oauth/login/call/",
  OAUTH_LOGIN_ONLY: URL_PREFIX.WEB_AFF + "/oauth/login_only/",
  OAUTH_LOGIN: URL_PREFIX.WEB_AFF + "/oauth/login/",
  SUBJECT_LOGIN_LIST: URL_PREFIX.WEB_AFF + "/subject/login_list/",
  SUBJECT_LOGIN: URL_PREFIX.WEB_AFF + "/subject/login/",
  LOGOUT: URL_PREFIX.WEB_AFF + "/logout/",
  // register
  REGISTER_EMAIL_USER_ONLY: URL_PREFIX.WEB_AFF + "/email/register/only_user/",
  REGISTER_EMAIL: URL_PREFIX.WEB_AFF + "/email/register/",
  REGISTER_MOBILE_USER_ONLY: URL_PREFIX.WEB_AFF + "/mobile/register/only_user/",
  REGISTER_MOBILE: URL_PREFIX.WEB_AFF + "/mobile/register/",
  // forget password
  RESET_BY_MOBILE: URL_PREFIX.WEB_AFF + "/mobile/password/reset/",
  RESET_BY_EMAIL: URL_PREFIX.WEB_AFF + "/email/password/reset/",
  // invite
  MOBILE_INVITE: URL_PREFIX.WEB_AFF + "/invitation/mobile/invite/",
  EMAIL_INVITE: URL_PREFIX.WEB_AFF + "/invitation/email/invite/",
  LARK_INVITE: URL_PREFIX.WEB_AFF + "/invitation/lark/invite/",
  INVITE_LIST: URL_PREFIX.WEB_AFF + "/invitation/list/",
  CANCEL_INVITE: URL_PREFIX.WEB_AFF + "/invitation/cancel/",
  RESEND_INVITE: URL_PREFIX.WEB_AFF + "/invitation/resend/",
  UPDATE_INVITE: URL_PREFIX.WEB_AFF + "/invitation/update/",
  CHECK_INVITE_VALID: URL_PREFIX.WEB_AFF + "/invitation/check/",
  ACCEPT_INVITE: URL_PREFIX.WEB_AFF + "/invitation/accept/",
  // subject
  CREATE_BY_USERNAME: URL_PREFIX.WEB_AFF + "/subject/username/create/",
  CREATE_BY_MOBILE: URL_PREFIX.WEB_AFF + "/subject/mobile/create/",
  CREATE_BY_EMAIL: URL_PREFIX.WEB_AFF + "/subject/email/create/",
  SUBJECT_LIST: URL_PREFIX.WEB_AFF + "/subject/all/list/",
  SUBJECT_DEPUTY_LIST: URL_PREFIX.WEB_AFF + "/subject/deputy/list/",
  SUBJECT_IDENTITY_LIST: URL_PREFIX.WEB_AFF + "/subject/identity/list/",
  UPDATE_DEPUTY_INFO: URL_PREFIX.WEB_AFF + "/deputy/update/",
  FREEZE_DEPUTY: URL_PREFIX.WEB_AFF + "/deputy/freeze/",
  DELETE_DEPUTY: URL_PREFIX.WEB_AFF + "/deputy/delete/",
  UPDATE_SUBJECT_INFO: URL_PREFIX.WEB_AFF + "/subject/update/",
  FREEZE_SUBJECT: URL_PREFIX.WEB_AFF + "/subject/freeze/",
  // resource
  RESOURCE_LIST: URL_PREFIX.WEB_AFF + "/resource/list/",
  // role
  CREATE_ROLE: URL_PREFIX.WEB_AFF + "/role/create/",
  UPDATE_ROLE: URL_PREFIX.WEB_AFF + "/role/update/",
  BAN_ROLE: URL_PREFIX.WEB_AFF + "/role/ban/",
  ROLE_LIST: URL_PREFIX.WEB_AFF + "/role/list/",
  ROLE_INFO: URL_PREFIX.WEB_AFF + "/role/info/",
  // user
  CREATE_USER_WITH_ROLE: URL_PREFIX.WEB_AFF + "/user/create_with_role/",
  ADD_USER_ROLE: URL_PREFIX.WEB_AFF + "/user_role/add/",
  DELETE_USER_ROLE: URL_PREFIX.WEB_AFF + "/user_role/del/",
  USER_ROLE_LIST: URL_PREFIX.WEB_AFF + "/user_role/list/",
  ALL_USER_ROLE_LIST: URL_PREFIX.WEB_AFF + "/user_role/all/list/",
  USER_PERMISSIONS: URL_PREFIX.WEB_AFF + "/user/permissions/",
  // super
  SUCCESSOR_SEND_CODE: URL_PREFIX.WEB_AFF + "/admin/successor/send_code/",
  TRANSFER_MANAGER: URL_PREFIX.WEB_AFF + "/admin/transfer/"
};
var WEB_SSO = {
  // 通用url
  // 手机验证码相关
  MOBILE_CODE_URL: '/send_activation_code/',
  MOBILE_CODE_URL_V2: '/send_activation_code/v2/',
  // 校验邮件
  EMAIL_ACTIVATE_URL: '/send_email_activate_link/',
  EMAIL_ACTIVATE_URL_V2: '/send_email_activate_link/v2/',
  // 邮箱验证码
  EMAIL_ACTIVATE_CODE_URL: '/send_email_activate_code/',
  EMAIL_ACTIVATE_CODE_URL_V2: '/send_email_activate_code/v2/',
  // login
  // 检查是否登录状态
  CHECK_LOGIN: '/check_login/',
  // 手机+验证码登录
  MOBILE_CODE_LOGIN_URL: '/quick_login/',
  MOBILE_CODE_LOGIN_URL_V2: '/quick_login/v2/',
  // 账号密码登录
  ACCOUNT_LOGIN_URL: '/account_login/',
  ACCOUNT_LOGIN_URL_V2: '/account_login/v2/',
  // 第三方登录
  AUTH_LOGIN_URL: '/passport/auth/wap_login/',
  // 带手机号三方登录
  BIND_WITH_MOBILE_LOGIN: '/bind_with_mobile_login/',
  AUTH_LOGIN: '/auth/login/',
  AUTH_LOGIN_ONLY: '/auth/login_only/',
  // 退出登陆
  LOGOUT: '/logout/',
  // register
  // 邮件验证码登录
  EMAIL_ACTIVATE_CODE_LOGIN: '/activate_email/code_login/',
  // 邮件验证码注册
  EMAIL_REGISTER: '/activate_email/register/',
  EMAIL_REGISTER_V2: '/activate_email/register/v2/',
  // 短信注册并绑定邮箱
  MOBILE_REGISTER_WITH_EMAIL: '/register/',
  MOBILE_REGISTER_WITH_EMAIL_V2: '/register/v2/',
  // password
  // SSO获取邮箱验证码
  SSO_EMAIL_ACTIVATE_CODE_URL: '/sso/send_email_activate_code/',
  // 重置密码
  RESET_PASSWORD: '/reset_password/',
  // bind_mobile
  // 绑定手机号
  BIND_MOBILE: '/bind_mobile/',
  // change_mobile
  // 绑定手机号变更
  CHANGE_MOBILE: '/change_mobile/',
  // quick_auth
  // 手机快速鉴权
  QUICK_AUTH: '/quick_auth/',
  // qrcode_login
  // 获取二维码
  GET_QRCODE: '/get_qrcode/',
  CHECK_QRCONNECT: '/check_qrconnect/',
  SCAN_QRCODE: '/scan_qrcode/',
  CONFIRM_QRCODE: '/confirm_qrcode/'
};
var APP_URL = {
  SEND_MOBILE_CODE: URL_PREFIX.APP + "/send_code/",
  CHECK_MOBILE_CODE: URL_PREFIX.APP + "/check_code/"
};

function loadScript(url, callback) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);

  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'complete' || script.readyState === 'loaded') {
        script.onreadystatechange = null;
        callback && callback();
      }
    };
  } else {
    script.onload = function () {
      callback && callback();
    };
  }
}

function getEnablePathList() {
  return [].concat(Object.values(WEB_URL), Object.values(WEB_AFF_URL), Object.values(WEB_SSO));
}

function initAcrawler(region, options) {
  var url = 'https://sf1-ttcdn-tos.pstatp.com/obj/rc-web-sdk/acrawler.js';

  if (region === 'gcs') {
    url = 'https://sf16-secsdk-va.ibytedtos.com/obj/rc-web-sdk-gcs/acrawler.js';
  } else if (region === 'sg') {
    url = 'https://sf16-secsdk-sg.ibytedtos.com/obj/rc-web-sdk-sg/acrawler.js';
  } else if (region === 'giso') {
    url = 'https://sf16-va.tiktokcdn-in.com/obj/rc-web-sdk-giso/acrawler.js';
  }

  loadScript(url, function () {
    var byted_acrawler = window.byted_acrawler;
    var enablePathList = getEnablePathList();

    if (byted_acrawler) {
      byted_acrawler.init({
        aid: options.aid,
        dfp: options.acrawler === 'cn' ? true : false,
        boe: options.isBoe || false,
        intercept: true,
        enablePathList: enablePathList
      });
    }
  });
}

var repeatRequest;
var defaultOptions = {
  commonOptions: {
    aid: 0,
    iid: '0',
    did: '0'
  },
  captchaOptions: {
    sideSlide: 'disabled',
    lang: 'zh',
    showMode: 'mask',
    region: 'cn',
    app_name: ''
  }
};
var captchaMap = {
  cn: CNCaptcha,
  sg: SGCaptcha,
  va: VACaptcha,
  "in": INCaptcha
};
var TTGCaptcha;

var initCaptcha = function initCaptcha(props) {
  var _props$isBoe = props.isBoe,
      isBoe = _props$isBoe === void 0 ? false : _props$isBoe,
      secondVerifyWebOptions = props.secondVerifyWebOptions;
  var defaultCaptchaHost = isBoe ? '//boe-verify.snssdk.com' : undefined;
  var options = {
    commonOptions: _extends({}, defaultOptions.commonOptions, {
      aid: props.aid,
      did: props.did ? String(props.did) : '0',
      iid: props.iid ? String(props.iid) : '0'
    }),
    captchaOptions: _extends({}, defaultOptions.captchaOptions, {
      sideSlide: props.captchaSideSlide || 'disabled',
      lang: props.language || 'zh',
      showMode: props.captchaShowMode || 'mask',
      region: props.region || 'cn',
      app_name: props.appName || '',
      host: props.captchaHost || defaultCaptchaHost
    }),
    secondVerifyWebOptions: secondVerifyWebOptions
  };
  TTGCaptcha = captchaMap[props.region || 'cn'] || CNCaptcha;
  TTGCaptcha.init(options, function () {}, function () {});
};

var sliderView = {
  init: function init(params) {
    var request = params.request,
        props = _objectWithoutPropertiesLoose(params, ["request"]);

    repeatRequest = request;
    initCaptcha(props);
  },
  show: function show(config) {
    var requestConfig = config.requestConfig,
        verifyData = config.verifyData;
    var parsedVerifyData = {};

    try {
      parsedVerifyData = JSON.parse(verifyData);
    } catch (e) {
      console.log('wrong desision config!');
    }

    return new Promise(function (resolve, reject) {
      TTGCaptcha.render({
        verify_data: parsedVerifyData,
        captchaOptions: {
          successCb: function () {
            try {
              return Promise.resolve(TTGCaptcha.getFp()).then(function (fp) {
                var _repeatRequest;

                console.log('>>>> 当前fp >>>>', fp);
                (_repeatRequest = repeatRequest) === null || _repeatRequest === void 0 ? void 0 : _repeatRequest(_extends({}, requestConfig, {
                  isResend: true,
                  params: _extends({}, requestConfig.params, {
                    fp: fp
                  })
                })).then(function (data) {
                  resolve(data);
                })["catch"](function (err) {
                  reject(err);
                });
              });
            } catch (e) {
              return Promise.reject(e);
            }
          },
          closeCb: function closeCb() {
            reject('CLOSE_CAPTCHA');
          }
        },
        secondVerifyWebOptions: {
          callBack: function (res) {
            try {
              var _repeatRequest2;

              (_repeatRequest2 = repeatRequest) === null || _repeatRequest2 === void 0 ? void 0 : _repeatRequest2(_extends({}, requestConfig, {
                isResend: true
              })).then(function (data) {
                resolve(data);
              })["catch"](function (err) {
                reject(err);
              });
              return Promise.resolve();
            } catch (e) {
              return Promise.reject(e);
            }
          },
          closeCallBack: function closeCallBack() {
            reject('SECOND_VALID');
          }
        }
      });
    });
  }
};

var data = {};
function set(key, value) {
  return new Promise(function (resolve) {
    data[key] = value;
    resolve(data);
  });
}
function get(key) {
  return data[key];
}

function getCookie(key) {
  var arr,
      reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)');

  if (arr = document.cookie.match(reg)) {
    return unescape(arr[2]);
  }

  return '';
}
function printGroupLog(title, content, style) {
  if (style === void 0) {
    style = true;
  }

  console.group(title);
  content && Object.keys(content).forEach(function (key) {
    style ? console.log(key, style || 'background: #222; color: #bada55', content[key]) : console.log(key, content[key]);
  });
  console.groupEnd();
}
/**
 * @param {string} str
 */

var writeUTF = function writeUTF(str) {
  var value = str.toString();
  var back = [];
  var code;

  for (var i = 0; i < value.length; i++) {
    code = value.charCodeAt(i);

    if (0x00 <= code && code <= 0x7f) {
      back.push(code);
    } else if (0x80 <= code && code <= 0x7ff) {
      back.push(192 | 31 & code >> 6);
      back.push(128 | 63 & code);
    } else if (0x800 <= code && code <= 0xd7ff || 0xe000 <= code && code <= 0xffff) {
      back.push(224 | 15 & code >> 12);
      back.push(128 | 63 & code >> 6);
      back.push(128 | 63 & code);
    }
  }

  for (var j = 0; j < back.length; j++) {
    back[j] &= 0xff;
  }

  return back;
};

var encrypt = function encrypt(value) {
  var result = [];
  var newCode = [];

  if (value === void 0) {
    return '';
  }

  newCode = writeUTF(value);

  for (var i = 0, length = newCode.length; i < length; ++i) {
    result.push((newCode[i] ^ 5).toString(16));
  }

  return result.join('');
};
/**
 * @param {object} params - what need to be encrypted
 * @param {string[]} keyList - the field to be encrypted
 */


var encryptParams = function encryptParams(params, keyList) {
  var value;
  var mix_mode = 0;
  var fixed_mix_mode = 0;

  if (typeof params !== 'object') {
    return params;
  }

  if (!keyList || keyList.length <= 0) {
    return params;
  }

  var newParams = _extends({
    mix_mode: mix_mode
  }, params);

  for (var i = 0, length = keyList.length; i < length; ++i) {
    value = newParams[keyList[i]];

    if (value !== void 0) {
      mix_mode |= 1;
      fixed_mix_mode |= 1;
      newParams[keyList[i]] = encrypt(value);
    }
  }

  newParams.mix_mode = mix_mode;
  newParams.fixed_mix_mode = fixed_mix_mode;
  return newParams;
};

var after = function after(res) {
  var _res$config, _res$headers, _resp3, _resp3$data, _resp4, _resp4$data, _resp5, _resp6;

  var url = (res === null || res === void 0 ? void 0 : (_res$config = res.config) === null || _res$config === void 0 ? void 0 : _res$config.url) || '';
  var logid = (res === null || res === void 0 ? void 0 : (_res$headers = res.headers) === null || _res$headers === void 0 ? void 0 : _res$headers['x-tt-logid']) || '';
  var resp = (res === null || res === void 0 ? void 0 : res.data) || {};
  var initProps = get('initProps');
  var printLog = (initProps === null || initProps === void 0 ? void 0 : initProps.printLog) || false;

  if (typeof resp === 'string') {
    try {
      resp = JSON.parse(resp);
    } catch (error) {
      console.log(error);
    }
  } // success


  if (resp && (resp.message === 'success' || resp.error_code === 0)) {
    var _resp;

    if (printLog) {
      printGroupLog("call " + url + " result >>>>", {
        '%cSUCCESS': resp.data || resp,
        '%cLogid': logid
      });
    } //  处理sso和web场景下内容不一致的问题


    return Promise.resolve(((_resp = resp) === null || _resp === void 0 ? void 0 : _resp.data) || resp);
  } // fail


  if (printLog) {
    var _resp2;

    printGroupLog("call " + url + " result >>>>", {
      '%cERROR': ((_resp2 = resp) === null || _resp2 === void 0 ? void 0 : _resp2.data) || resp,
      '%cLogid': logid
    });
  } // slider


  var sliderDecisionConfig = ((_resp3 = resp) === null || _resp3 === void 0 ? void 0 : (_resp3$data = _resp3.data) === null || _resp3$data === void 0 ? void 0 : _resp3$data.verify_center_decision_conf) || ((_resp4 = resp) === null || _resp4 === void 0 ? void 0 : (_resp4$data = _resp4.data) === null || _resp4$data === void 0 ? void 0 : _resp4$data.verify_center_secondary_decision_conf) || ((_resp5 = resp) === null || _resp5 === void 0 ? void 0 : _resp5.verify_center_decision_conf) || ((_resp6 = resp) === null || _resp6 === void 0 ? void 0 : _resp6.verify_center_secondary_decision_conf);

  if (sliderDecisionConfig) {
    return Promise.resolve(sliderView.show({
      verifyData: sliderDecisionConfig,
      requestConfig: res === null || res === void 0 ? void 0 : res.config
    })).then(function (data) {
      return Promise.resolve(data);
    })["catch"](function (err) {
      return Promise.reject(err);
    });
  } else {
    var _resp7;

    var formatResp = ((_resp7 = resp) === null || _resp7 === void 0 ? void 0 : _resp7.data) || resp;
    return Promise.reject(_extends({}, formatResp, {
      log_id: logid
    }));
  }
};
var before = function before(config, commonParams) {
  if (commonParams === void 0) {
    commonParams = {};
  }

  var initProps = get('initProps');
  var printLog = (initProps === null || initProps === void 0 ? void 0 : initProps.printLog) || false;

  var _config$isResend = config.isResend,
      isResend = _config$isResend === void 0 ? false : _config$isResend,
      requestConfig = _objectWithoutPropertiesLoose(config, ["isResend"]);

  var url = requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.url;
  var method = (requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.method) || 'get';
  var data = (requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.data) || {}; // csrf headers

  var csrfHeader = {
    'x-tt-passport-csrf-token': getCookie('passport_csrf_token') || getCookie('passport_csrf_token_default') || ''
  };
  var headers = Object.assign({
    'Content-Type': 'application/x-www-form-urlencoded',
    Accept: 'application/json, text/javascript'
  }, config.headers || {}, csrfHeader);
  requestConfig.headers = headers; // log

  if (printLog) {
    printGroupLog(method + " " + url + " >>>>", {
      '%cdata >>>>': data,
      '%ccommon params >>>>': commonParams
    });
  } // whether the request is resent due to slider verification code


  if (isResend) {
    return requestConfig; // return Promise.resolve(requestConfig);
  } // filter data, only get defined fields


  var filterData = {};
  Object.keys(data).filter(function (key) {
    return data[key] !== undefined;
  }).forEach(function (key) {
    filterData[key] = data[key];
  }); // data transform

  if (['post', 'POST'].includes(method)) {
    requestConfig.params = commonParams;
    requestConfig.data = Object.keys(filterData).map(function (key) {
      var value = requestConfig.data[key];

      if (typeof value === 'object') {
        return encodeURIComponent(key) + "=" + encodeURIComponent(JSON.stringify(value));
      } else {
        return encodeURIComponent(key) + "=" + encodeURIComponent(value);
      }
    }).join('&');
  }

  if (['get', 'GET'].includes(method)) {
    requestConfig.params = _extends({}, filterData, commonParams);
  }

  return requestConfig; // return Promise.resolve(requestConfig);
};

function createXHR(commonParams) {
  var initProps = get('initProps');
  var xhr = axios.create({
    baseURL: (initProps === null || initProps === void 0 ? void 0 : initProps.host) || window && "https://" + window.location.hostname,
    withCredentials: true
  });
  xhr.interceptors.request.use(function (config) {
    return before(config, commonParams);
  }, undefined);
  xhr.interceptors.response.use(after, undefined);
  return xhr;
}

function parseResponse(config) {
  var _config$data, _config$data$data;

  var resp = (config === null || config === void 0 ? void 0 : (_config$data = config.data) === null || _config$data === void 0 ? void 0 : (_config$data$data = _config$data.data) === null || _config$data$data === void 0 ? void 0 : _config$data$data.response) || (config === null || config === void 0 ? void 0 : config.data) || {};

  if (typeof resp === 'string') {
    try {
      resp = JSON.parse(resp);
    } catch (error) {
      console.log('fetch', error);
    }
  }

  return resp;
}

var after$1 = function after(res) {
  var _res$config, _res$headers, _resp$data;

  var url = (res === null || res === void 0 ? void 0 : (_res$config = res.config) === null || _res$config === void 0 ? void 0 : _res$config.url) || '';
  var logid = (res === null || res === void 0 ? void 0 : (_res$headers = res.headers) === null || _res$headers === void 0 ? void 0 : _res$headers['x-tt-logid']) || '';
  var resp = parseResponse(res);
  var initProps = get('initProps');
  var printLog = (initProps === null || initProps === void 0 ? void 0 : initProps.printLog) || false; // success

  if ((resp === null || resp === void 0 ? void 0 : resp.message) === 'success') {
    if (printLog) {
      printGroupLog("call " + url + " result >>>>", {
        SUCCESS: resp.data,
        Logid: logid
      }, false);
    }

    return Promise.resolve(resp.data);
  } // fail


  if (printLog) {
    printGroupLog("call " + url + " result >>>>", {
      ERROR: resp.data,
      Logid: logid
    }, false);
  } // slider


  var ifShowCaptcha = !(initProps !== null && initProps !== void 0 && initProps.appShowCaptcha);
  var sliderDecisionConfig = resp === null || resp === void 0 ? void 0 : (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.verify_center_decision_conf;

  if (ifShowCaptcha && sliderDecisionConfig) {
    return Promise.resolve(sliderView.show({
      verifyData: sliderDecisionConfig,
      requestConfig: res === null || res === void 0 ? void 0 : res.config
    }));
  }

  return Promise.reject(_extends({}, resp.data, {
    log_id: logid
  }));
};

var adapterInit = function adapterInit() {
  return function (config) {
    var baseURL = config.baseURL,
        path = config.url,
        _config$method = config.method,
        method = _config$method === void 0 ? 'GET' : _config$method,
        _config$params = config.params,
        params = _config$params === void 0 ? {} : _config$params,
        _config$data = config.data,
        data = _config$data === void 0 ? {} : _config$data;
    var initProps = get('initProps');
    var fetch = initProps.fetch;
    var printLog = (initProps === null || initProps === void 0 ? void 0 : initProps.printLog) || false;
    var url = baseURL + path; // log

    if (printLog) {
      printGroupLog(method + " " + url + " >>>>", {
        'data >>>>': data,
        'params >>>>': params
      }, false);
    }

    var requestData = {
      url: url,
      method: method.toUpperCase(),
      params: _extends({}, params, {
        is_native_h5: 1
      }),
      data: data,
      needCommonParams: true,
      header: {
        'x-tt-passport-csrf-token': getCookie('passport_csrf_token') || getCookie('passport_csrf_token_default') || ''
      }
    };
    return fetch(requestData).then(function (data) {
      return {
        data: data,
        status: 200,
        statusText: 'ok',
        config: config
      };
    });
  };
};

function createFetch() {
  var initProps = get('initProps');
  var xhr = axios.create({
    baseURL: (initProps === null || initProps === void 0 ? void 0 : initProps.host) || window && "https://" + window.location.hostname,
    adapter: adapterInit(),
    withCredentials: true,
    transformRequest: [function (data) {
      var dataObj = data;

      if (typeof data === 'string') {
        try {
          dataObj = JSON.parse(data);
        } catch (error) {
          console.log(error);
        }
      }

      return dataObj;
    }]
  });
  xhr.interceptors.response.use(after$1, undefined);
  return xhr;
}

var BaseInterface = function BaseInterface(props, type) {
  var _props$scene = props.scene,
      scene = _props$scene === void 0 ? 'normal' : _props$scene,
      aid = props.aid,
      _props$language = props.language,
      language = _props$language === void 0 ? '' : _props$language,
      _props$subjectAid = props.subjectAid,
      subjectAid = _props$subjectAid === void 0 ? 0 : _props$subjectAid;
  set('initProps', props);
  var params; // Handling common parameters in fetch -- web

  if (type === 'web') {
    var commonParams = {
      aid: aid,
      account_sdk_source: 'web'
    }; // language

    if (language) {
      commonParams.language = language;
    }

    if (scene === 'aff') {
      commonParams.subject_aid = subjectAid;
    }

    params = commonParams;
  }

  if (type === 'sso') {
    var _commonParams = {
      aid: aid
    };
    params = _commonParams;
  }

  this.request = new RequestBehavior(params);
  sliderView.init(_extends({}, props, {
    request: this.request
  }));
}; //  class request

var RequestBehavior = function RequestBehavior(commonParams) {
  var _get;

  if ((_get = get('initProps')) !== null && _get !== void 0 && _get.fetch) {
    return createFetch();
  } else {
    return createXHR(commonParams);
  }
};

var LoginAPI = function LoginAPI(props) {
  var _this = this;

  /**
   * @param {string} mobile - the mobile used to login
   * @return {Promise} send result
   */
  this.sendCode = function (params) {
    var mobile = params.mobile;
    var data = encryptParams({
      mobile: mobile,
      type: 7
    }, ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile used to login
   * @param {string} code - the captcha
   * @param {number} need_frozen_user - whether return users in frozen
   * @return {Promise} login result
   */


  this.smsLogin = function (params) {
    var mobile = params.mobile,
        code = params.code,
        _params$need_frozen_u = params.need_frozen_user,
        need_frozen_user = _params$need_frozen_u === void 0 ? 0 : _params$need_frozen_u;
    var data = encryptParams({
      mobile: mobile,
      code: code,
      need_frozen_user: need_frozen_user,
      type: 7
    }, ['mobile', 'type', 'code']);
    return _this.request({
      url: WEB_AFF_URL.SMS_LOGIN,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} email - the email used to login
   * @return {Promise} send result
   */


  this.sendEmailCode = function (params) {
    var email = params.email;
    var data = encryptParams({
      email: email,
      type: 13
    }, ['email', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email used to login
   * @param {string} code - the captcha
   * @param {number} need_frozen_user - whether return users in frozen
   * @return {Promise} login result
   */


  this.emailLogin = function (params) {
    var email = params.email,
        code = params.code,
        _params$need_frozen_u2 = params.need_frozen_user,
        need_frozen_user = _params$need_frozen_u2 === void 0 ? 0 : _params$need_frozen_u2;
    var data = encryptParams({
      email: email,
      code: code,
      need_frozen_user: need_frozen_user,
      type: 13
    }, ['email', 'type', 'code']);
    return _this.request({
      url: WEB_AFF_URL.EMAIL_LOGIN,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} email - the email used to login
   * @param {string} username - the username used to login
   * @param {string} mobile - the mobile used to login
   * @param {string} account - the account used to login, whose value shoule be email or username or mobile
   * @param {string} password - corresponding password
   * @param {number} need_frozen_user - whether return users in frozen
   * @return {Promise} login result
   */


  this.pwdLogin = function (params) {
    var _encryptParams;

    var password = params.password,
        _params$need_frozen_u3 = params.need_frozen_user,
        need_frozen_user = _params$need_frozen_u3 === void 0 ? 0 : _params$need_frozen_u3;
    var loginType = ['email', 'username', 'mobile', 'account'].find(function (item) {
      return !!params[item];
    });

    if (!loginType) {
      return Promise.reject();
    }

    var data = encryptParams((_encryptParams = {
      password: password
    }, _encryptParams[loginType] = params[loginType], _encryptParams.need_frozen_user = need_frozen_user, _encryptParams), ['password', loginType]);
    return _this.request({
      url: WEB_AFF_URL.PWD_LOGIN,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {number} platform_app_id - the app id of the third party used to login
   * @param {string} next - encoded redirect url after successful authorization
   * @return {Promise} authorize result
   */


  this.oauthLoginCall = function (params) {
    var platform_app_id = params.platform_app_id,
        next = params.next;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.OAUTH_LOGIN_CALL,
        method: 'GET',
        data: {
          platform_app_id: platform_app_id,
          next: next
        }
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} platform_app_id - the app id of the third party used to login
   * @param {string} redirect_uri - parameter 'oauth_redirect_uri' in the url query after calling oauthLoginCall successfully
   * @param {string} code - parameter 'oauth_code' in the url query after calling oauthLoginCall successfully
   * @param {number} need_frozen_user - whether return users in frozen
   * @param {string} login_only - 'true' for only login, 'false' for register and login
   * @return {Promise} login result
   */


  this.oauthLogin = function (params) {
    var platform_app_id = params.platform_app_id,
        redirect_uri = params.redirect_uri,
        code = params.code,
        _params$need_frozen_u4 = params.need_frozen_user,
        need_frozen_user = _params$need_frozen_u4 === void 0 ? 0 : _params$need_frozen_u4,
        _params$login_only = params.login_only,
        login_only = _params$login_only === void 0 ? true : _params$login_only;
    return _this.request({
      url: login_only ? WEB_AFF_URL.OAUTH_LOGIN_ONLY : WEB_AFF_URL.OAUTH_LOGIN,
      method: 'POST',
      data: {
        platform_app_id: platform_app_id,
        redirect_uri: redirect_uri,
        code: code,
        need_frozen_user: need_frozen_user
      }
    });
  };
  /**
   * @return {Promise} list of companies the user can login
   */


  this.subjectLoginList = function () {
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SUBJECT_LOGIN_LIST,
        method: 'GET'
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} login_subject_uid - the id of the subject user want to login
   * @param {string} user_identity_id - the id of the user who wants to login
   * @return {Promise} login result
   */


  this.subjectLogin = function (params) {
    var login_subject_uid = params.login_subject_uid,
        _params$user_identity = params.user_identity_id,
        user_identity_id = _params$user_identity === void 0 ? '0' : _params$user_identity;
    var data = encryptParams({
      login_subject_uid: login_subject_uid,
      user_identity_id: user_identity_id
    }, ['login_subject_uid', 'user_identity_id']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SUBJECT_LOGIN,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} next - the redirect url after logout successfully
   * @return {Promise} logout result
   */


  this.logout = function (params) {
    var _params$next = params.next,
        next = _params$next === void 0 ? '' : _params$next;

    var _ref = get('initProps') || {},
        aid = _ref.aid,
        subjectAid = _ref.subjectAid;

    var nextUrl = encodeURIComponent(next);
    window.location.href = WEB_AFF_URL.LOGOUT + "?account_sdk_source=web&aid=" + aid + "&subject_aid=" + subjectAid + "&next=" + nextUrl;
  };

  var request = props.request;
  this.request = request;
};

var RegisterAPI = function RegisterAPI(props) {
  var _this = this;

  /**
   * @param {string} email - the email used to register
   * @return {Promise} send result
   */
  this.sendEmailCode = function (params) {
    var email = params.email,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      email: email,
      type: 1
    }, extra_params), ['email', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email to be verified
   * @param {string} code - the email captcha
   * @return {Promise} verify result
   */


  this.verifyEmail = function (params) {
    var email = params.email,
        code = params.code,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      type: 1
    }, extra_params), ['email', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CHECK_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} ticket - the ticket gained from verification
   * @param {string} base_infos
   * @param {string} subject_name
   * @param {string} password
   * @param {string} identity_card
   * @param {string} real_name
   * @param {string} only_user - whether register user account only
   * @return {Promise} register result
   */


  this.registerByEmail = function (params) {
    var _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3,
        _params$only_user = params.only_user,
        only_user = _params$only_user === void 0 ? false : _params$only_user,
        props = _objectWithoutPropertiesLoose(params, ["extra_params", "only_user"]);

    var data = encryptParams(_extends({}, props, extra_params), ['base_infos', 'subject_name', 'password', 'identity_card', 'real_name']);
    var url = only_user ? WEB_AFF_URL.REGISTER_EMAIL_USER_ONLY : WEB_AFF_URL.REGISTER_EMAIL;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: url,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile used to register
   * @return {Promise} send result
   */


  this.sendMobileCode = function (params) {
    var mobile = params.mobile,
        _params$extra_params4 = params.extra_params,
        extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: 1
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile to be verified
   * @param {string} code - the mobile captcha
   * @return {Promise} verify result
   */


  this.verifyMobile = function (params) {
    var mobile = params.mobile,
        code = params.code,
        _params$extra_params5 = params.extra_params,
        extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      type: 1
    }, extra_params), ['mobile', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CHECK_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} ticket - the ticket gained from verification
   * @param {string} base_infos
   * @param {string} subject_name
   * @param {string} password
   * @param {string} identity_card
   * @param {string} real_name
   * @param {string} only_user - whether register user account only
   * @return {Promise} register result
   */


  this.registerByMobile = function (params) {
    var _params$extra_params6 = params.extra_params,
        extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6,
        _params$only_user2 = params.only_user,
        only_user = _params$only_user2 === void 0 ? false : _params$only_user2,
        props = _objectWithoutPropertiesLoose(params, ["extra_params", "only_user"]);

    var data = encryptParams(_extends({}, props, extra_params), ['base_infos', 'subject_name', 'password', 'identity_card', 'real_name']);
    var url = only_user ? WEB_AFF_URL.REGISTER_MOBILE_USER_ONLY : WEB_AFF_URL.REGISTER_MOBILE;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: url,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  var request = props.request;
  this.request = request;
};

var ForgetPwdAPI = function ForgetPwdAPI(props) {
  var _this = this;

  /**
   * @param {string} email - the email used to recall password
   * @return {Promise} send result
   */
  this.sendEmailCode = function (params) {
    var email = params.email;
    var data = encryptParams({
      email: email,
      type: 4
    }, ['email', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile used to recall password
   * @return {Promise} send result
   */


  this.sendMobileCode = function (params) {
    var mobile = params.mobile;
    var data = encryptParams({
      mobile: mobile,
      type: 6
    }, ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile used to reset password
   * @param {string} code - the captcha
   * @param {string} password - new password
   * @return {Promise} reset result
   */


  this.mobileReset = function (params) {
    var mobile = params.mobile,
        code = params.code,
        password = params.password;
    var data = encryptParams({
      mobile: mobile,
      code: code,
      password: password
    }, ['mobile', 'code', 'password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.RESET_BY_MOBILE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email used to reset password
   * @param {string} code - the captcha
   * @param {string} password - new password
   * @return {Promise} reset result
   */


  this.emailReset = function (params) {
    var email = params.email,
        code = params.code,
        password = params.password;
    var data = encryptParams({
      email: email,
      code: code,
      password: password
    }, ['email', 'code', 'password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.RESET_BY_EMAIL,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  var request = props.request;
  this.request = request;
};

var InviteAPI = function InviteAPI(props) {
  var _this = this;

  /**
   * @param {string} mobile - the mobile used to invite
   * @param {number} deputy_identity_id - character of invitation authorization
   * @param {string} invited_name - the name of the invited user
   * @param {string} next_url - the redirect url after accepting invitation
   * @param {string} link - landing page of invitation
   * @param {string} role_keys - keys of role, joined by ','
   * @param {string} permissions - joined by ','
   * @return {Promise} invite result
   */
  this.mobileInvite = function (params) {
    var _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params,
        props = _objectWithoutPropertiesLoose(params, ["extra_params"]);

    var data = encryptParams(_extends({}, props, extra_params), ['mobile']);
    return _this.request({
      url: WEB_AFF_URL.MOBILE_INVITE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} email - the email used to invite
   * @param {number} deputy_identity_id - character of invitation authorization
   * @param {string} invited_name - the name of the invited user
   * @param {string} next_url - the redirect url after accepting invitation
   * @param {string} link - landing page of invitation
   * @param {string} role_keys - keys of role, joined by ','
   * @param {string} permissions - joined by ','
   * @return {Promise} invite result
   */


  this.emailInvite = function (params) {
    var _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2,
        props = _objectWithoutPropertiesLoose(params, ["extra_params"]);

    var data = encryptParams(_extends({}, props, extra_params), ['email']);
    return _this.request({
      url: WEB_AFF_URL.EMAIL_INVITE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} email - the email used to invite
   * @param {number} deputy_identity_id - character of invitation authorization
   * @param {string} invited_name - the name of the invited user
   * @param {string} role_keys - keys of role, joined by ','
   * @param {string} permissions - joined by ','
   * @return {Promise} invite result
   */


  this.larkInvite = function (params) {
    var _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3,
        props = _objectWithoutPropertiesLoose(params, ["extra_params"]);

    var data = encryptParams(_extends({}, props, extra_params), ['email']);
    return _this.request({
      url: WEB_AFF_URL.LARK_INVITE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @return {Promise} request result
   */


  this.getInvitationList = function (params) {
    var _params$page = params.page,
        page = _params$page === void 0 ? 1 : _params$page,
        _params$page_size = params.page_size,
        page_size = _params$page_size === void 0 ? 10 : _params$page_size,
        _params$extra_params4 = params.extra_params,
        extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: "" + WEB_AFF_URL.INVITE_LIST + page + "/",
        method: 'GET',
        data: _extends({
          page_size: page_size
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} invite_id - the invitation id
   * @return {Promise} cancel result
   */


  this.cancelInvitation = function (params) {
    var _params$invite_id = params.invite_id,
        invite_id = _params$invite_id === void 0 ? 0 : _params$invite_id,
        _params$extra_params5 = params.extra_params,
        extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CANCEL_INVITE,
        method: 'POST',
        data: _extends({
          invite_id: invite_id
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} invite_id - the invitation id
   * @param {string} next_url - the redirect url after accepting invitation
   * @return {Promise} resend result
   */


  this.resendInvitation = function (params) {
    var _params$invite_id2 = params.invite_id,
        invite_id = _params$invite_id2 === void 0 ? 0 : _params$invite_id2,
        _params$next_url = params.next_url,
        next_url = _params$next_url === void 0 ? '' : _params$next_url,
        _params$extra_params6 = params.extra_params,
        extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.RESEND_INVITE,
        method: 'POST',
        data: _extends({
          invite_id: invite_id,
          next_url: next_url
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} invite_id - the invitation id
   * @param {number} deputy_identity_id - character of invitation authorization
   * @param {string} deputy_name - inviter name
   * @return {Promise} update result
   */


  this.updateInvitation = function (params) {
    var _params$invite_id3 = params.invite_id,
        invite_id = _params$invite_id3 === void 0 ? 0 : _params$invite_id3,
        deputy_identity_id = params.deputy_identity_id,
        deputy_name = params.deputy_name,
        _params$extra_params7 = params.extra_params,
        extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    var data = encryptParams(_extends({
      invite_id: invite_id,
      deputy_identity_id: deputy_identity_id,
      deputy_name: deputy_name
    }, extra_params), ['deputy_name']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.UPDATE_INVITE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} invite_ticket - invitation ticket carried in the query of invitation link, only necessary when the user is not login
   * @return {Promise} check result
   */


  this.checkRegisterStatus = function (params) {
    var invite_ticket = params.invite_ticket,
        _params$extra_params8 = params.extra_params,
        extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CHECK_INVITE_VALID,
        method: 'POST',
        data: _extends({
          invite_ticket: invite_ticket
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} invite_ticket - invitation ticket carried in the query of invitation link, only necessary when the user is not login
   * @param {string} invite_code
   * @param {string} password - necessary when the user is new user
   * @return {Promise} accept result
   */


  this.acceptInvitation = function (params) {
    var invite_ticket = params.invite_ticket,
        invite_code = params.invite_code,
        password = params.password,
        _params$extra_params9 = params.extra_params,
        extra_params = _params$extra_params9 === void 0 ? {} : _params$extra_params9;
    var data = encryptParams({
      invite_ticket: invite_ticket,
      invite_code: invite_code,
      password: password,
      extra_params: extra_params
    }, ['invite_code', 'password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.ACCEPT_INVITE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  var request = props.request;
  this.request = request;
};

var SubjectAPI = function SubjectAPI(props) {
  var _this = this;

  /**
   * @param {string} subject_name
   * @param {string} deputy_name - name of the principal of subject
   * @param {string} password
   * @param {string} username
   * @param {number} deputy_identity_id
   * @param {string} base_infos - basic info
   * @param {string} detail_infos
   * @return {Promise} create result
   */
  this.createByUsername = function (params) {
    var _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params,
        props = _objectWithoutPropertiesLoose(params, ["extra_params"]);

    var data = encryptParams(_extends({}, props, extra_params), ['subject_name', 'deputy_name', 'password', 'username', 'base_infos', 'detail_infos']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CREATE_BY_USERNAME,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} subject_name
   * @param {string} deputy_name - name of the principal of subject
   * @param {string} password
   * @param {string} mobile
   * @param {number} deputy_identity_id
   * @param {string} base_infos - basic info
   * @param {string} detail_infos
   * @return {Promise} create result
   */


  this.createByMobile = function (params) {
    var _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2,
        props = _objectWithoutPropertiesLoose(params, ["extra_params"]);

    var data = encryptParams(_extends({}, props, extra_params), ['subject_name', 'deputy_name', 'password', 'mobile', 'base_infos', 'detail_infos']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CREATE_BY_MOBILE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} subject_name
   * @param {string} deputy_name - name of the principal of subject
   * @param {string} password
   * @param {string} email
   * @param {number} deputy_identity_id
   * @param {string} base_infos - basic info
   * @param {string} detail_infos
   * @return {Promise} create result
   */


  this.createByEmail = function (params) {
    var _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3,
        props = _objectWithoutPropertiesLoose(params, ["extra_params"]);

    var data = encryptParams(_extends({}, props, extra_params), ['subject_name', 'deputy_name', 'password', 'email', 'base_infos', 'detail_infos']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CREATE_BY_EMAIL,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @param {number} deputy_identity_id
   * @return {Promise} request result
   */


  this.getSubjectList = function (params) {
    var _params$page = params.page,
        page = _params$page === void 0 ? 1 : _params$page,
        _params$page_size = params.page_size,
        page_size = _params$page_size === void 0 ? 10 : _params$page_size,
        deputy_identity_id = params.deputy_identity_id,
        _params$extra_params4 = params.extra_params,
        extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: "" + WEB_AFF_URL.SUBJECT_LIST + page + "/",
        method: 'GET',
        data: _extends({
          page_size: page_size,
          deputy_identity_id: deputy_identity_id
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @return {Promise} request result
   */


  this.getSubjectDeputyList = function (params) {
    var _params$page2 = params.page,
        page = _params$page2 === void 0 ? 1 : _params$page2,
        _params$page_size2 = params.page_size,
        page_size = _params$page_size2 === void 0 ? 10 : _params$page_size2,
        _params$extra_params5 = params.extra_params,
        extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: "" + WEB_AFF_URL.SUBJECT_DEPUTY_LIST + page + "/",
        method: 'GET',
        data: _extends({
          page_size: page_size
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @return {Promise} request result
   */


  this.getSubjectIdentityList = function (params) {
    var _params$page3 = params.page,
        page = _params$page3 === void 0 ? 1 : _params$page3,
        _params$page_size3 = params.page_size,
        page_size = _params$page_size3 === void 0 ? 10 : _params$page_size3,
        _params$extra_params6 = params.extra_params,
        extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: "" + WEB_AFF_URL.SUBJECT_IDENTITY_LIST + page + "/",
        method: 'GET',
        data: _extends({
          page_size: page_size
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} sec_user_id - encrypted uid
   * @param {number} deputy_identity_id
   * @param {string} deputy_name
   * @param {string} user_identity_id
   * @return {Promise} update result
   */


  this.updateDeputyInfo = function (params) {
    var sec_user_id = params.sec_user_id,
        deputy_identity_id = params.deputy_identity_id,
        deputy_name = params.deputy_name,
        user_identity_id = params.user_identity_id,
        _params$extra_params7 = params.extra_params,
        extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    var data = encryptParams(_extends({
      sec_user_id: sec_user_id,
      deputy_identity_id: deputy_identity_id,
      deputy_name: deputy_name,
      user_identity_id: user_identity_id
    }, extra_params), ['deputy_name', 'user_identity_id']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.UPDATE_DEPUTY_INFO,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} sec_user_id - encrypted uid
   * @param {string} user_identity_id
   * @param {number} is_frozen - whether to freeze
   * @return {Promise} freeze result
   */


  this.freezeDeputy = function (params) {
    var sec_user_id = params.sec_user_id,
        user_identity_id = params.user_identity_id,
        _params$is_frozen = params.is_frozen,
        is_frozen = _params$is_frozen === void 0 ? 0 : _params$is_frozen,
        _params$extra_params8 = params.extra_params,
        extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8;
    var data = encryptParams(_extends({
      sec_user_id: sec_user_id,
      user_identity_id: user_identity_id,
      is_frozen: is_frozen
    }, extra_params), ['sec_user_id', 'user_identity_id']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.FREEZE_DEPUTY,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} sec_user_id - encrypted uid
   * @param {string} user_identity_id
   * @return {Promise} delete result
   */


  this.deleteDeputy = function (params) {
    var sec_user_id = params.sec_user_id,
        user_identity_id = params.user_identity_id,
        _params$extra_params9 = params.extra_params,
        extra_params = _params$extra_params9 === void 0 ? {} : _params$extra_params9;
    var data = encryptParams(_extends({
      sec_user_id: sec_user_id,
      user_identity_id: user_identity_id
    }, extra_params), ['user_identity_id']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.DELETE_DEPUTY,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} sec_subject_uid - encrypted subject uid
   * @param {string} subject_name
   * @param {string} base_infos
   * @param {string} detail_infos
   * @return {Promise} update result
   */


  this.updateSubjectInfo = function (params) {
    var sec_subject_uid = params.sec_subject_uid,
        subject_name = params.subject_name,
        base_infos = params.base_infos,
        detail_infos = params.detail_infos,
        _params$extra_params10 = params.extra_params,
        extra_params = _params$extra_params10 === void 0 ? {} : _params$extra_params10;
    var data = encryptParams(_extends({
      sec_subject_uid: sec_subject_uid,
      subject_name: subject_name,
      base_infos: base_infos,
      detail_infos: detail_infos
    }, extra_params), ['sec_subject_uid', 'subject_name', 'base_infos', 'detail_infos']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.UPDATE_SUBJECT_INFO,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} sec_subject_uid - encrypted subject uid
   * @param {number} is_frozen - whether to freeze
   * @return {Promise} freeze result
   */


  this.freezeSubject = function (params) {
    var sec_subject_uid = params.sec_subject_uid,
        _params$is_frozen2 = params.is_frozen,
        is_frozen = _params$is_frozen2 === void 0 ? 0 : _params$is_frozen2,
        _params$extra_params11 = params.extra_params,
        extra_params = _params$extra_params11 === void 0 ? {} : _params$extra_params11;
    var data = encryptParams(_extends({
      sec_subject_uid: sec_subject_uid,
      is_frozen: is_frozen
    }, extra_params), ['sec_subject_uid']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.FREEZE_SUBJECT,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  var request = props.request;
  this.request = request;
};

var ResourceAPI = function ResourceAPI(props) {
  var _this = this;

  /**
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @param {number} subject_uid - id of subject
   * @return {Promise} request result
   */
  this.getResourceList = function (params) {
    var _params$page = params.page,
        page = _params$page === void 0 ? 1 : _params$page,
        _params$page_size = params.page_size,
        page_size = _params$page_size === void 0 ? 10 : _params$page_size,
        subject_uid = params.subject_uid,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: "" + WEB_AFF_URL.RESOURCE_LIST + page + "/",
        method: 'GET',
        data: _extends({
          page_size: page_size,
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  var request = props.request;
  this.request = request;
};

var RoleAPI = function RoleAPI(props) {
  var _this = this;

  /**
   * @param {string} role_name - name
   * @param {string} permissions - concatenation of resources permissions
   * @param {number} subject_uid - id of subject
   * @return {Promise} create result
   */
  this.createRole = function (params) {
    var role_name = params.role_name,
        permissions = params.permissions,
        subject_uid = params.subject_uid,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CREATE_ROLE,
        method: 'POST',
        data: _extends({
          role_name: role_name,
          permissions: permissions,
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} role_key - id of role
   * @param {string} role_name - name
   * @param {string} permissions - concatenation of resources permissions
   * @param {string} description - description
   * @param {number} subject_uid - id of subject
   * @return {Promise} update result
   */


  this.updateRole = function (params) {
    var role_key = params.role_key,
        role_name = params.role_name,
        permissions = params.permissions,
        description = params.description,
        subject_uid = params.subject_uid,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.UPDATE_ROLE,
        method: 'POST',
        data: _extends({
          role_key: role_key,
          role_name: role_name,
          permissions: permissions,
          description: description,
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} role_key - id of role
   * @param {number} subject_uid - id of subject
   * @return {Promise} ban result
   */


  this.banRole = function (params) {
    var role_key = params.role_key,
        subject_uid = params.subject_uid,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.BAN_ROLE,
        method: 'POST',
        data: _extends({
          role_key: role_key,
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} subject_uid - id of subject
   * @return {Promise} request result
   */


  this.getRoleList = function (params) {
    var subject_uid = params.subject_uid,
        _params$extra_params4 = params.extra_params,
        extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.ROLE_LIST,
        method: 'GET',
        data: _extends({
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} role_key - id of role
   * @param {number} subject_uid - id of subject
   * @return {Promise} request result
   */


  this.getRoleInfo = function (params) {
    var role_key = params.role_key,
        subject_uid = params.subject_uid,
        _params$extra_params5 = params.extra_params,
        extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.ROLE_INFO,
        method: 'GET',
        data: _extends({
          role_key: role_key,
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  var request = props.request;
  this.request = request;
};

var UserAPI = function UserAPI(props) {
  var _this = this;

  /**
   * @param {string} role_key - id of role
   * @param {string} sec_user_id - encrypted user id
   * @param {string} name - user name
   * @param {number} identity_id - id of identity
   * @param {number} subject_uid - id of subject
   * @return {Promise} create result
   */
  this.createUserWithRole = function (params) {
    var role_key = params.role_key,
        sec_user_id = params.sec_user_id,
        name = params.name,
        identity_id = params.identity_id,
        subject_uid = params.subject_uid,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CREATE_USER_WITH_ROLE,
        method: 'POST',
        data: _extends({
          role_key: role_key,
          sec_user_id: sec_user_id,
          name: name,
          identity_id: identity_id,
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} role_key - id of role
   * @param {string} sec_user_identity_ids - encrypted user id seperated by ','
   * @param {number} subject_uid - id of subject
   * @return {Promise} add result
   */


  this.addUserRole = function (params) {
    var role_key = params.role_key,
        sec_user_identity_ids = params.sec_user_identity_ids,
        subject_uid = params.subject_uid,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.ADD_USER_ROLE,
        method: 'POST',
        data: _extends({
          role_key: role_key,
          sec_user_identity_ids: sec_user_identity_ids,
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} role_key - id of role
   * @param {string} sec_user_identity_ids - encrypted user id seperated by ','
   * @param {number} subject_uid - id of subject
   * @return {Promise} delete result
   */


  this.deleteUserRole = function (params) {
    var role_key = params.role_key,
        sec_user_identity_ids = params.sec_user_identity_ids,
        subject_uid = params.subject_uid,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.DELETE_USER_ROLE,
        method: 'POST',
        data: _extends({
          role_key: role_key,
          sec_user_identity_ids: sec_user_identity_ids,
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} subject_uid - id of subject
   * @return {Promise} request result
   */


  this.getUserRoleList = function (params) {
    var subject_uid = params.subject_uid,
        _params$extra_params4 = params.extra_params,
        extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.USER_ROLE_LIST,
        method: 'GET',
        data: _extends({
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} subject_uid - id of subject
   * @param {number} identity_id - id of identity
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @return {Promise} request result
   */


  this.getAllUserRoleList = function (params) {
    var subject_uid = params.subject_uid,
        identity_id = params.identity_id,
        _params$page = params.page,
        page = _params$page === void 0 ? 1 : _params$page,
        _params$page_size = params.page_size,
        page_size = _params$page_size === void 0 ? 10 : _params$page_size,
        _params$extra_params5 = params.extra_params,
        extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: "" + WEB_AFF_URL.ALL_USER_ROLE_LIST + page + "/",
        method: 'GET',
        data: _extends({
          subject_uid: subject_uid,
          identity_id: identity_id,
          page_size: page_size
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} subject_uid - id of subject
   * @return {Promise} request result
   */


  this.getUserPermissions = function (params) {
    var subject_uid = params.subject_uid,
        _params$extra_params6 = params.extra_params,
        extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.USER_PERMISSIONS,
        method: 'GET',
        data: _extends({
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  var request = props.request;
  this.request = request;
};

var SuperAPI = function SuperAPI(props) {
  var _this = this;

  /**
   * @return {Promise} send result
   */
  this.sendCodeToOldManager = function (params) {
    if (params === void 0) {
      params = {};
    }

    var _params = params,
        _params$extra_params = _params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      type: 22
    }, extra_params), ['type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @return {Promise} send result
   */


  this.sendEmailCodeToOldManager = function (params) {
    if (params === void 0) {
      params = {};
    }

    var _params2 = params,
        _params2$extra_params = _params2.extra_params,
        extra_params = _params2$extra_params === void 0 ? {} : _params2$extra_params;
    var data = encryptParams(_extends({
      type: 6
    }, extra_params), ['type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} code - the captcha
   * @return {Promise} verify result
   */


  this.verifyOldManagerMobile = function (params) {
    var code = params.code,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      code: code,
      type: 22
    }, extra_params), ['code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.VERIFY_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} code - the captcha
   * @return {Promise} verify result
   */


  this.verifyOldManagerEmail = function (params) {
    var code = params.code,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      code: code,
      type: 6
    }, extra_params), ['code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.VERIFY_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - mobile number
   * @param {string} verify_ticket - the ticket returned by verification
   * @return {Promise} send result
   */


  this.sendCodeToNewManager = function (params) {
    var mobile = params.mobile,
        verify_ticket = params.verify_ticket,
        _params$extra_params4 = params.extra_params,
        extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      mobile: mobile,
      verify_ticket: verify_ticket,
      type: 101
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - email address
   * @param {string} verify_ticket - the ticket returned by verification
   * @return {Promise} send result
   */


  this.sendEmailCodeToNewManager = function (params) {
    var email = params.email,
        verify_ticket = params.verify_ticket,
        _params$extra_params5 = params.extra_params,
        extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    var data = encryptParams(_extends({
      email: email,
      verify_ticket: verify_ticket,
      type: 101
    }, extra_params), ['email', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - mobile number
   * @param {number} code - the captcha
   * @return {Promise} verify result
   */


  this.verifyNewManagerMobile = function (params) {
    var mobile = params.mobile,
        code = params.code,
        _params$extra_params6 = params.extra_params,
        extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      type: 101
    }, extra_params), ['mobile', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CHECK_MOBILE_CODE,
        method: 'GET',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - email address
   * @param {number} code - the captcha
   * @return {Promise} verify result
   */


  this.verifyNewManagerEmail = function (params) {
    var email = params.email,
        code = params.code,
        _params$extra_params7 = params.extra_params,
        extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      type: 101
    }, extra_params), ['email', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CHECK_EMAIL_CODE,
        method: 'GET',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} new_user_name - name of new manager
   * @param {string} new_admin_verify_ticket - verify ticket of new manager
   * @param {string} old_admin_verify_ticket - the ticket returned by verification
   * @param {number} old_admin_target_identity_id - the identity id of old manager after transfer
   * @param {string} new_admin_sec_user_id - the encrypted user id of new manager
   * @param {string} new_admin_sec_user_identity_id - the encrypted user identity id of new manager
   * @return {Promise} verify result
   */


  this.transferManager = function (params) {
    var _params$extra_params8 = params.extra_params,
        extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8,
        props = _objectWithoutPropertiesLoose(params, ["extra_params"]);

    return _this.request({
      url: WEB_AFF_URL.TRANSFER_MANAGER,
      method: 'POST',
      data: _extends({}, props, extra_params)
    });
  };

  var request = props.request;
  this.request = request;
};

var LoginAPI$1 = function LoginAPI(props) {
  var _this = this;

  /**
   * @param {string} mobile - the mobile used to login
   * @return {Promise} send result
   */
  this.sendCode = function (params) {
    var mobile = params.mobile,
        _params$registerOnly = params.registerOnly,
        registerOnly = _params$registerOnly === void 0 ? false : _params$registerOnly,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: registerOnly ? 16 : 24
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile used to login
   * @param {string} code - the captcha
   * @param {boolean} login_only - 'true' for only login, 'false' for register and login
   * @return {Promise} login result
   */


  this.smsLogin = function (params) {
    var mobile = params.mobile,
        code = params.code,
        _params$login_only = params.login_only,
        login_only = _params$login_only === void 0 ? false : _params$login_only,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code
    }, extra_params), ['mobile', 'code']);
    var url = login_only ? WEB_URL.SMS_LOGIN_ONLY : WEB_URL.SMS_LOGIN;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: url,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile used to login
   * @param {string} sms_code_key - the ticket gained from sms login only
   * @return {Promise} login result
   */


  this.smsLoginContinue = function (params) {
    var mobile = params.mobile,
        sms_code_key = params.sms_code_key,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      mobile: mobile,
      sms_code_key: sms_code_key
    }, extra_params), ['mobile', 'sms_code_key']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SMS_LOGIN_CONTINUE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} platform_app_id - the id of third party
   * @param {string} next - redirect url after successful login
   * @return {Promise} login result
   */


  this.webLogin = function (params) {
    var platform_app_id = params.platform_app_id,
        next = params.next,
        _params$extra_params4 = params.extra_params,
        extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SMS_LOGIN_CONTINUE,
        method: 'POST',
        data: _extends({
          platform_app_id: platform_app_id,
          next: next
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email used to login
   * @param {string} password - corresponding password
   * @return {Promise} login result
   */


  this.emailLogin = function (params) {
    var email = params.email,
        password = params.password,
        _params$extra_params5 = params.extra_params,
        extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    var data = encryptParams(_extends({
      email: email,
      password: password
    }, extra_params), ['email', 'password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.EMAIL_LOGIN,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} account - the account to login
   * @param {string} password - corresponding password
   * @return {Promise} login result
   */


  this.pwdLogin = function (params) {
    var account = params.account,
        password = params.password,
        _params$extra_params6 = params.extra_params,
        extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    var data = encryptParams(_extends({
      account: account,
      password: password
    }, extra_params), ['account', 'password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.PWD_LOGIN,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} platform_app_id - the app id of the third party used to login
   * @param {string} code - authorization code
   * @param {string} access_token - third-party authorization token
   * @param {string} access_token_secret - id token, only neccessary when using google to login
   * @param {string} openid - third-party openid, used with access_token
   * @param {string} profile_key - third-party ticket that preserves information temporaily, used when the login progress is blocked
   * @param {boolean} login_only - whether to login only, not allowing to register
   * @return {Promise} login result
   */


  this.authLogin = function (params) {
    var platform_app_id = params.platform_app_id,
        code = params.code,
        access_token = params.access_token,
        access_token_secret = params.access_token_secret,
        openid = params.openid,
        profile_key = params.profile_key,
        _params$login_only2 = params.login_only,
        login_only = _params$login_only2 === void 0 ? false : _params$login_only2,
        _params$extra_params7 = params.extra_params,
        extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: login_only ? WEB_URL.AUTH_LOGIN_ONLY : WEB_URL.AUTH_LOGIN,
        method: 'POST',
        data: _extends({
          platform_app_id: platform_app_id,
          code: code,
          access_token: access_token,
          access_token_secret: access_token_secret,
          openid: openid,
          profile_key: profile_key
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} access_token - third-party authorization token
   * @param {string} access_token_secret - id token, only neccessary when using google to login
   * @param {string} code - authorization code
   * @param {number} expires_in - expires time of access_token
   * @param {string} openid - third-party openid, used with access_token
   * @param {number} platform_app_id - the app id of the third party used to login
   * @param {string} platform - name of third party platform
   * @param {boolean} need_plaintext - whether to return mobile in plaintext
   * @param {string} profile_key - third-party ticket that preserves information temporaily
   * @return {Promise} login result
   */


  this.getOauthMobile = function (params) {
    var access_token = params.access_token,
        access_token_secret = params.access_token_secret,
        code = params.code,
        expires_in = params.expires_in,
        openid = params.openid,
        platform_app_id = params.platform_app_id,
        platform = params.platform,
        _params$need_plaintex = params.need_plaintext,
        need_plaintext = _params$need_plaintex === void 0 ? false : _params$need_plaintex,
        profile_key = params.profile_key,
        _params$extra_params8 = params.extra_params,
        extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.MOBILE_OAUTH,
        method: 'POST',
        data: _extends({
          access_token: access_token,
          access_token_secret: access_token_secret,
          code: code,
          expires_in: expires_in,
          openid: openid,
          platform_app_id: platform_app_id,
          platform: platform,
          need_plaintext: need_plaintext,
          profile_key: profile_key
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} platform_app_id - the app id of the third party used to login
   * @param {string} code - authorization code
   * @param {string} profile_key - third-party ticket that preserves information temporaily, used when the login progress is blocked
   * @param {string} mobile - phone number
   * @param {string} sms_code - captcha
   * @return {Promise} login result
   */


  this.authBindLogin = function (params) {
    var platform_app_id = params.platform_app_id,
        code = params.code,
        mobile = params.mobile,
        sms_code = params.sms_code,
        sms_code_key = params.sms_code_key,
        profile_key = params.profile_key,
        _params$extra_params9 = params.extra_params,
        extra_params = _params$extra_params9 === void 0 ? {} : _params$extra_params9;
    var data = encryptParams(_extends({
      platform_app_id: platform_app_id,
      code: code,
      mobile: mobile,
      sms_code: sms_code,
      sms_code_key: sms_code_key,
      profile_key: profile_key
    }, extra_params), ['mobile', 'sms_code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.AUTH_BIND_ONLY,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile used to login
   * @param {string} code - the captcha
   * @param {string} profile_key - a parameter returned by login_only interface
   */


  this.mobileBindLogin = function (params) {
    var code = params.code,
        mobile = params.mobile,
        profile_key = params.profile_key,
        _params$extra_params10 = params.extra_params,
        extra_params = _params$extra_params10 === void 0 ? {} : _params$extra_params10;
    var data = encryptParams(_extends({
      code: code,
      mobile: mobile,
      profile_key: profile_key
    }, extra_params), ['mobile', 'code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.MOBILE_BIND_ONLY,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} next - the redirect url after successful logout
   */


  this.logout = function (params) {
    var _get;

    var _params$next = params.next,
        next = _params$next === void 0 ? '/' : _params$next;
    var aid = ((_get = get('initProps')) === null || _get === void 0 ? void 0 : _get.aid) || '';
    var nextUrl = encodeURIComponent(next);
    window.location.href = WEB_URL.LOGOUT + "?account_sdk_source=web&aid=" + aid + "&next=" + nextUrl;
  };
  /**
   * @param {string} email - the email used to login
   * @param {string} next - the url attached to the email
   * @param {string} password - corresponding password
   * @return {Promise} send result
   */


  this.sendEmailCode = function (params) {
    var email = params.email,
        next = params.next,
        password = params.password,
        _params$extra_params11 = params.extra_params,
        extra_params = _params$extra_params11 === void 0 ? {} : _params$extra_params11;
    var data = encryptParams(_extends({
      email: email,
      next: next,
      password: password,
      type: 1
    }, extra_params), ['email', 'password', 'type']);
    return _this.request({
      url: WEB_URL.SEND_EMAIL_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} email - the email used to login
   * @param {string} code - the captcha
   * @param {string} password - corresponding password
   * @return {Promise} send result
   */


  this.emailRegister = function (params) {
    var email = params.email,
        code = params.code,
        password = params.password,
        _params$ifLogin = params.ifLogin,
        ifLogin = _params$ifLogin === void 0 ? false : _params$ifLogin,
        _params$extra_params12 = params.extra_params,
        extra_params = _params$extra_params12 === void 0 ? {} : _params$extra_params12;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      password: password,
      type: 1
    }, extra_params), ['email', 'password', 'type', 'code']);
    return _this.request({
      url: ifLogin ? WEB_URL.EMAIL_REGISTER_LOGIN : WEB_URL.EMAIL_REGISTER,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} mobile - the mobile used to login
   * @param {string} code - the captcha
   * @param {string} password - corresponding password
   * @return {Promise} register result
   */


  this.mobileRegister = function (params) {
    var mobile = params.mobile,
        code = params.code,
        password = params.password,
        _params$extra_params13 = params.extra_params,
        extra_params = _params$extra_params13 === void 0 ? {} : _params$extra_params13;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      password: password,
      type: 16
    }, extra_params), ['mobile', 'code', 'password', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.MOBILE_REGISTER,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile used to login
   * @param {string} sms_code - the sms captcha
   * @param {string} email - the email used to login
   * @param {string} email_code - the email captcha
   * @param {string} password - corresponding password
   * @param {string} verify_ticket - the ticket returned by server during last verification process
   * @return {Promise} register result
   */


  this.mobileEmailRegister = function (params) {
    var mobile = params.mobile,
        sms_code = params.sms_code,
        email = params.email,
        email_code = params.email_code,
        password = params.password,
        verify_ticket = params.verify_ticket,
        _params$extra_params14 = params.extra_params,
        extra_params = _params$extra_params14 === void 0 ? {} : _params$extra_params14;
    var data = encryptParams(_extends({
      mobile: mobile,
      sms_code: sms_code,
      email: email,
      email_code: email_code,
      password: password,
      verify_ticket: verify_ticket,
      sms_type: 1,
      ect_type: 1
    }, extra_params), ['mobile', 'sms_code', 'sms_type', 'email', 'email_code', 'ect_type', 'password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.MOBILE_EMAIL_REGISTER,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @return {Promise} check result
   */


  this.checkLogin = function (params) {
    if (params === void 0) {
      params = {};
    }

    var _params = params,
        _params$extra_params15 = _params.extra_params,
        extra_params = _params$extra_params15 === void 0 ? {} : _params$extra_params15;
    return _this.request({
      url: WEB_URL.CHECK_LOGIN,
      method: 'GET',
      data: extra_params
    });
  };
  /**
   * @param {string} code - user code returned by open service
   * @param {string} profile_key - user code returned by other process
   * @param {number} platform_app_id - apply for configuration in appcloud
   * @param {string} platform - third-party name
   * @param {number} need_mobile - whether synchronize the mobile of third-party account
   * @param {number} check_mobile - whether restrict old user to bind mobile forcely
   * @param {number} change_bind - whether rebind forcely when conflict occurs
   * @return {Promise} login result
   */


  this.bindWithMobileLogin = function (params) {
    var _params$extra_params16 = params.extra_params,
        extra_params = _params$extra_params16 === void 0 ? {} : _params$extra_params16,
        props = _objectWithoutPropertiesLoose(params, ["extra_params"]);

    return _this.request({
      url: WEB_URL.BIND_WITH_MOBILE_LOGIN,
      method: 'POST',
      data: _extends({}, extra_params, props)
    });
  };
  /**
   * @param {number} platform_app_id - apply for configuration in appcloud
   * @param {string} next - redirect url after successful login
   * @param {number} use_local_host
   * @param {string} action - login_only || ''
   */


  this.thirdAuth = function (params) {
    var _get2;

    var platform_app_id = params.platform_app_id,
        _params$next2 = params.next,
        next = _params$next2 === void 0 ? '/' : _params$next2,
        _params$use_local_hos = params.use_local_host,
        use_local_host = _params$use_local_hos === void 0 ? 0 : _params$use_local_hos,
        action = params.action;
    var aid = ((_get2 = get('initProps')) === null || _get2 === void 0 ? void 0 : _get2.aid) || '';
    var nextUrl = encodeURIComponent(next);
    window.location.href = WEB_URL.THIRD_AUTH + "?account_sdk_source=web&aid=" + aid + "&next=" + nextUrl + "&platform_app_id=" + platform_app_id + "&use_local_host=" + use_local_host + "&action=" + action;
  };

  var request = props.request;
  this.request = request;
};

var QrCodeLoginAPI = /*#__PURE__*/function () {
  function QrCodeLoginAPI(props) {
    var request = props.request;
    this.request = request;
  }
  /**
   * [get qrcode url]
   * @param {string} next redirect url after login success
   */


  var _proto = QrCodeLoginAPI.prototype;

  _proto.getQrcode = function getQrcode(params) {
    var next = params.next;
    return this.request({
      url: WEB_URL.GET_QRCODE,
      method: 'GET',
      data: {
        next: encodeURIComponent(next)
      }
    });
  }
  /**
   * [query qrCode status]
   * @param {string} next	 redirect url after login success
   * @param {string} token result of GetQrcode
   */
  ;

  _proto.checkQrconnect = function checkQrconnect(params) {
    var next = params.next,
        token = params.token;
    return this.request({
      url: WEB_URL.CHECK_QRCONNECT,
      method: 'GET',
      data: {
        next: encodeURIComponent(next),
        token: token
      }
    });
  };

  return QrCodeLoginAPI;
}();

var BindAPI = function BindAPI(props) {
  var _this = this;

  /**
   * @param {string} mobile - the mobile about to bind
   * @param {number} unbind_exist - whether unbind forcely when the mobile is already bound to another account
   * @return {Promise} send result
   */
  this.sendCode = function (params) {
    var mobile = params.mobile,
        _params$unbind_exist = params.unbind_exist,
        unbind_exist = _params$unbind_exist === void 0 ? 0 : _params$unbind_exist;
    var data = encryptParams({
      mobile: mobile,
      type: 17,
      unbind_exist: unbind_exist
    }, ['mobile', 'type', 'unbind_exist']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile about to bind
   * @param {string} code - the captcha
   * @param {string} password - if you want to set password
   * @param {number} unbind_exist - whether unbind forcely when the mobile is already bound to another account
   * @return {Promise} bind result
   */


  this.bindMobile = function (params) {
    var mobile = params.mobile,
        code = params.code,
        password = params.password,
        _params$unbind_exist2 = params.unbind_exist,
        unbind_exist = _params$unbind_exist2 === void 0 ? 0 : _params$unbind_exist2;
    var data = encryptParams({
      mobile: mobile,
      code: code,
      password: password,
      unbind_exist: unbind_exist,
      type: 17
    }, ['mobile', 'code', 'password', 'unbind_exist', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.MOBILE_BIND,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email about to bind
   * @return {Promise} bind result
   */


  this.sendEmailCode = function (params) {
    var email = params.email,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      email: email,
      type: 8
    }, extra_params), ['email', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email about to bind
   * @param {string} code - the captcha
   * @return {Promise} bind result
   */


  this.bindEmail = function (params) {
    var email = params.email,
        code = params.code,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      email: email,
      code: code
    }, extra_params), ['email', 'code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.EMAIL_BIND,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} platform_app_id - the app id of the third party about to bind
   * @param {string} code - authorization code
   * @param {string} access_token - third-party authorization token
   * @param {string} access_token_secret - id token
   * @param {string} openid - third-party openid, used with access_token, only neccessary for wechat, douyin and toutiao
   * @param {string} profile_key - third-party ticket that preserves information temporaily, used when the login progress is blocked
   * @return {Promise} bind result
   */


  this.bindAuth = function (params) {
    var platform_app_id = params.platform_app_id,
        code = params.code,
        access_token = params.access_token,
        access_token_secret = params.access_token_secret,
        openid = params.openid,
        profile_key = params.profile_key,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.AUTH_BIND,
        method: 'POST',
        data: _extends({
          platform_app_id: platform_app_id,
          code: code,
          access_token: access_token,
          access_token_secret: access_token_secret,
          openid: openid,
          profile_key: profile_key
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} platform - the platform about to unbind
   * @return {Promise} unbind result
   */


  this.unbindAuth = function (params) {
    var platform = params.platform,
        _params$extra_params4 = params.extra_params,
        extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.AUTH_UNBIND,
        method: 'POST',
        data: _extends({
          platform: platform
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} platform_app_id - the app id of the third party about to bind
   * @param {string} profile_key - third-party ticket that preserves information temporaily
   * @return {Promise} switch result
   */


  this.switchBindAuth = function (params) {
    var platform_app_id = params.platform_app_id,
        profile_key = params.profile_key,
        _params$extra_params5 = params.extra_params,
        extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.AUTH_SWITCH_BIND,
        method: 'POST',
        data: _extends({
          platform_app_id: platform_app_id,
          profile_key: profile_key
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  var request = props.request;
  this.request = request;
};

var ExtraAPI = function ExtraAPI(props) {
  var _this = this;

  /**
   * @param {string} mobile - the mobile to check
   * @return {Promise} check result
   */
  this.checkMobileRegistered = function (params) {
    var mobile = params.mobile,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      mobile: mobile
    }, extra_params), ['mobile']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.CHECK_MOBILE_REGISTER,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email to check
   * @return {Promise} check result
   */


  this.checkEmailRegistered = function (params) {
    var email = params.email,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      email: email
    }, extra_params), ['email']);
    return _this.request({
      url: WEB_URL.CHECK_EMAIL_REGISTER,
      method: 'POST',
      data: data
    });
  };

  var request = props.request;
  this.request = request;
};

// import { encryptParams } from '../../utils/index';
var RegisterAPI$1 = function RegisterAPI(props) {
  var request = props.request;
  this.request = request;
};

var ForgetPwdAPI$1 = function ForgetPwdAPI(props) {
  var _this = this;

  /**
   * @param {string} mobile - the mobile used to verify user's identity
   * @return {Promise} send result
   */
  this.sendCode = function (params) {
    var mobile = params.mobile,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: 6
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password - the new password
   * @param {string} mobile - the mobile used to verify user's identity
   * @param {string} code - the captcha
   * @return {Promise} reset result
   */


  this.resetPwdByMobile = function (params) {
    var password = params.password,
        mobile = params.mobile,
        code = params.code,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      password: password,
      mobile: mobile,
      code: code
    }, extra_params), ['password', 'mobile', 'code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.RESET_PWD_BY_MOBILE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email used to verify user's identity
   * @return {Promise} send result
   */


  this.sendEmailCode = function (params) {
    var email = params.email,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      email: email,
      type: 4
    }, extra_params), ['email', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password - the new password
   * @param {string} email - the email used to verify user's identity
   * @param {string} code - the captcha
   * @return {Promise} reset result
   */


  this.resetPwdByEmail = function (params) {
    var password = params.password,
        email = params.email,
        code = params.code,
        _params$extra_params4 = params.extra_params,
        extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      password: password,
      email: email,
      code: code
    }, extra_params), ['password', 'email', 'code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.RESET_PWD_BY_EMAIL,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password - the new password
   * @param {string} ticket - the ticket returned after mobile verification
   * @return {Promise} reset result
   */


  this.resetPwdByMobileTicket = function (params) {
    var password = params.password,
        ticket = params.ticket,
        _params$extra_params5 = params.extra_params,
        extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    var data = encryptParams(_extends({
      password: password,
      ticket: ticket
    }, extra_params), ['password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.RESET_PWD_BY_MOBILE_TICKET,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password - the new password
   * @param {string} ticket - the ticket returned after email verification
   * @return {Promise} reset result
   */


  this.resetPwdByEmailTicket = function (params) {
    var password = params.password,
        ticket = params.ticket,
        _params$extra_params6 = params.extra_params,
        extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    var data = encryptParams(_extends({
      password: password,
      ticket: ticket
    }, extra_params), ['password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.RESET_PWD_BY_EMAIL_TICKET,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  var request = props.request;
  this.request = request;
};

var RebindAPI = function RebindAPI(props) {
  var _this = this;

  /**
   * @param {string} mobile - the mobile about to unbind
   * @param {boolean} use_bind_mobile - true for using the binded mobile, false for using the mobile in the parameters
   * @return {Promise} send result
   */
  this.sendCodeToOldMobile = function (params) {
    var mobile = params.mobile,
        _params$use_bind_mobi = params.use_bind_mobile,
        use_bind_mobile = _params$use_bind_mobi === void 0 ? true : _params$use_bind_mobi,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var type = use_bind_mobile ? 22 : 28;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: type
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} code - the code received by the old mobile
   * @param {boolean} use_bind_mobile - true for using the binded mobile, false for using the mobile in the parameters
   * @return {Promise} verify result
   */


  this.validateOldMobile = function (params) {
    var code = params.code,
        _params$use_bind_mobi2 = params.use_bind_mobile,
        use_bind_mobile = _params$use_bind_mobi2 === void 0 ? true : _params$use_bind_mobi2,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var type = use_bind_mobile ? 22 : 28;
    var data = encryptParams(_extends({
      code: code,
      type: type
    }, extra_params), ['code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.VERIFY_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile about to bind
   * @param {string} old_mobile - the mobile about to unbind
   * @param {string} ticket - the ticket returned from <validateOldMobile>
   * @return {Promise} send result
   */


  this.sendCodeToNewMobile = function (params) {
    var mobile = params.mobile,
        old_mobile = params.old_mobile,
        ticket = params.ticket,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      mobile: mobile,
      old_mobile: old_mobile,
      type: 20,
      ticket: ticket
    }, extra_params), ['mobile', 'old_mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile about to bind
   * @param {string} code - the captcha
   * @param {string} ticket - the ticket returned from <validateOldMobile>
   * @param {number} kick_other - whether kick off the login status of other devices, 0 for no, 1 for yes
   * @return {Promise} bind result
   */


  this.rebindMobile = function (params) {
    var mobile = params.mobile,
        code = params.code,
        ticket = params.ticket,
        _params$kick_other = params.kick_other,
        kick_other = _params$kick_other === void 0 ? 0 : _params$kick_other,
        _params$extra_params4 = params.extra_params,
        extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      ticket: ticket,
      kick_other: kick_other
    }, extra_params), ['mobile', 'code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.MOBILE_REBIND,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email about to unbind
   * @return {Promise} send result
   */


  this.sendCodeToOldEmail = function (params) {
    var email = params.email,
        _params$extra_params5 = params.extra_params,
        extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    var data = encryptParams(_extends({
      email: email,
      type: 6
    }, extra_params), ['email', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email about to unbind
   * @param {string} code - the code received by the old mobile
   * @return {Promise} verify result
   */


  this.validateOldEmail = function (params) {
    var email = params.email,
        code = params.code,
        _params$extra_params6 = params.extra_params,
        extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      type: 6
    }, extra_params), ['email', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.VERIFY_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email about to bind
   * @return {Promise} send result
   */


  this.sendCodeToNewEmail = function (params) {
    var email = params.email,
        _params$extra_params7 = params.extra_params,
        extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    var data = encryptParams(_extends({
      email: email,
      type: 7
    }, extra_params), ['email', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email about to bind
   * @param {string} code - the captcha
   * @param {string} ticket - the ticket returned from <validateOldEmail>
   * @return {Promise} bind result
   */


  this.rebindEmail = function (params) {
    var email = params.email,
        code = params.code,
        ticket = params.ticket,
        _params$extra_params8 = params.extra_params,
        extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      type: 7,
      ticket: ticket
    }, extra_params), ['email', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.EMAIL_REBIND,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  var request = props.request;
  this.request = request;
};

var PasswordAPI = function PasswordAPI(props) {
  var _this = this;

  /**
   * @param {boolean} verify_mobile_seperate - whether to verify the mobile captcha seperately
   * @return {Promise} send result
   */
  this.sendCode = function (params) {
    if (params === void 0) {
      params = {};
    }

    var _params = params,
        _params$verify_mobile = _params.verify_mobile_seperate,
        verify_mobile_seperate = _params$verify_mobile === void 0 ? false : _params$verify_mobile,
        _params$extra_params = _params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var type = verify_mobile_seperate ? 22 : 13;
    var data = encryptParams(_extends({
      type: type
    }, extra_params), ['type']);
    return _this.request({
      url: WEB_URL.SEND_MOBILE_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} code - the captcha
   * @return {Promise} verify result
   */


  this.validateMobile = function (params) {
    var code = params.code,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      code: code,
      type: 22
    }, extra_params), ['code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.VERIFY_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password - new password
   * @param {string} code - the captcha
   * @param {string} ticket - the ticket returned after mobile verification
   * @return {Promise} change result
   */


  this.changePwdByMobile = function (params) {
    var password = params.password,
        code = params.code,
        ticket = params.ticket,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      password: password,
      code: code,
      ticket: ticket
    }, extra_params), ['password', 'code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.PWD_CHANGE_BY_MOBILE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password - new password
   * @param {string} current_password - old password
   * @return {Promise} update result
   */


  this.updatePwd = function (params) {
    var password = params.password,
        current_password = params.current_password,
        _params$extra_params4 = params.extra_params,
        extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      password: password,
      current_password: current_password
    }, extra_params), ['password', 'current_password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.PWD_UPDATE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @return {Promise} send result
   */


  this.sendEmailCode = function (params) {
    if (params === void 0) {
      params = {};
    }

    var _params2 = params,
        _params2$extra_params = _params2.extra_params,
        extra_params = _params2$extra_params === void 0 ? {} : _params2$extra_params;
    var data = encryptParams(_extends({
      type: 11
    }, extra_params), ['type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} code - the captcha
   * @return {Promise} verify result
   */


  this.validateEmail = function (params) {
    var code = params.code,
        _params$extra_params5 = params.extra_params,
        extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    var data = encryptParams(_extends({
      code: code,
      type: 11
    }, extra_params), ['code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.VERIFY_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password - new password
   * @param {string} code - the captcha
   * @param {string} ticket - the ticket returned after email verification
   * @return {Promise} change result
   */


  this.changePwdByEmail = function (params) {
    var password = params.password,
        code = params.code,
        ticket = params.ticket,
        _params$extra_params6 = params.extra_params,
        extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    var data = encryptParams(_extends({
      password: password,
      code: code,
      ticket: ticket
    }, extra_params), ['password', 'code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.PWD_CHANGE_BY_EMAIL,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password
   * @return {Promise} set result
   */


  this.setPassword = function (params) {
    var password = params.password,
        _params$extra_params7 = params.extra_params,
        extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    var data = encryptParams(_extends({
      password: password
    }, extra_params), ['password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.PWD_SET,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @return {Promise} check result
   */


  this.checkHasSetPwd = function (params) {
    if (params === void 0) {
      params = {};
    }

    var _params3 = params,
        _params3$extra_params = _params3.extra_params,
        extra_params = _params3$extra_params === void 0 ? {} : _params3$extra_params;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.PWD_HAS_SET,
        method: 'POST',
        data: extra_params
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  var request = props.request;
  this.request = request;
};

var VerifyAPI = function VerifyAPI(props) {
  var _this = this;

  /**
   * @param {string} mobile - mobile to be verified
   * @return {Promise} - send result
   */
  this.notLoginSendCode = function (params) {
    var mobile = params.mobile,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: 34
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - mobile to be verified
   * @param {string} code - the captcha
   * @return {Promise} - verify result
   */


  this.notLoginValidateMobile = function (params) {
    var mobile = params.mobile,
        code = params.code,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      type: 34
    }, extra_params), ['mobile', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.CHECK_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - email to be verified
   * @return {Promise} - send result
   */


  this.notLoginSendEmailCode = function (params) {
    var email = params.email,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      email: email,
      type: 15
    }, extra_params), ['email', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - email to be verified
   * @param {string} code - the captcha
   * @return {Promise} - verify result
   */


  this.notLoginValidateEmail = function (params) {
    var email = params.email,
        code = params.code,
        _params$extra_params4 = params.extra_params,
        extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      type: 15
    }, extra_params), ['email', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.CHECK_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @return {Promise} - send result
   */


  this.sendCode = function (params) {
    if (params === void 0) {
      params = {};
    }

    var _params = params,
        _params$extra_params5 = _params.extra_params,
        extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    var data = encryptParams(_extends({
      type: 22
    }, extra_params), ['type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} code - the captcha
   * @return {Promise} - verify result
   */


  this.validateMobile = function (params) {
    var code = params.code,
        _params$extra_params6 = params.extra_params,
        extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    var data = encryptParams(_extends({
      code: code,
      type: 22
    }, extra_params), ['code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.VERIFY_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @return {Promise} - send result
   */


  this.sendEmailCode = function (params) {
    if (params === void 0) {
      params = {};
    }

    var _params2 = params,
        _params2$extra_params = _params2.extra_params,
        extra_params = _params2$extra_params === void 0 ? {} : _params2$extra_params;
    var data = encryptParams(_extends({
      type: 6
    }, extra_params), ['type']);
    return _this.request({
      url: WEB_URL.SEND_EMAIL_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} code - the captcha
   * @return {Promise} - verify result
   */


  this.validateEmail = function (params) {
    var code = params.code,
        _params$extra_params7 = params.extra_params,
        extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    var data = encryptParams(_extends({
      code: code,
      type: 6
    }, extra_params), ['code', 'type']);
    return _this.request({
      url: WEB_URL.VERIFY_EMAIL_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} account - account to be verified, mobile / email / username
   * @param {string} password - corresponding password
   * @return {Promise} - verify result
   */


  this.accountVerify = function (params) {
    var account = params.account,
        password = params.password,
        _params$extra_params8 = params.extra_params,
        extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8;
    var data = encryptParams(_extends({
      account: account,
      password: password,
      user_login_version: 1
    }, extra_params), ['account', 'password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.ACCOUNT_VERIFY,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} platform_app_id - the app id of the third party used to login
   * @param {string} code - authorization code
   * @param {string} access_token - third-party authorization token
   * @param {string} access_token_secret - id token, only neccessary when using google to login
   * @param {string} openid - third-party openid, used with access_token
   * @param {string} profile_key - third-party ticket that preserves information temporaily, used when the login progress is blocked
   * @return {Promise} login result
   */


  this.authVerify = function (params) {
    var platform_app_id = params.platform_app_id,
        code = params.code,
        access_token = params.access_token,
        access_token_secret = params.access_token_secret,
        openid = params.openid,
        profile_key = params.profile_key,
        _params$extra_params9 = params.extra_params,
        extra_params = _params$extra_params9 === void 0 ? {} : _params$extra_params9;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.AUTH_VERIFY,
        method: 'POST',
        data: _extends({
          platform_app_id: platform_app_id,
          code: code,
          access_token: access_token,
          access_token_secret: access_token_secret,
          openid: openid,
          profile_key: profile_key
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  var request = props.request;
  this.request = request;
};

var CancelAPI = function CancelAPI(props) {
  var _this = this;

  /**
   * @param {string} cancel_ticket - Ticket returned by cancel_check API
   * @return {Promise} - result
   */
  this.verifyWay = function (params) {
    var cancel_ticket = params.cancel_ticket,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    return _this.request({
      url: WEB_URL.CANCEL_VERIFY_WAY,
      method: 'GET',
      data: _extends({
        cancel_ticket: cancel_ticket
      }, extra_params)
    });
  };
  /**
   * @param {string} value_ticket - A ticket representing the value of the user
   * @return {Promise} - result
   */


  this.checkIfPass = function (params) {
    var value_ticket = params.value_ticket,
        extra_params = params.extra_params;
    return _this.request({
      url: WEB_URL.CANCEL_CHECK,
      method: 'GET',
      data: _extends({
        value_ticket: value_ticket
      }, extra_params)
    });
  };
  /**
   * @param {string} value_ticket - A ticket representing the value of the user
   * @param {string} token - A ticket obtained after verification such as mobile phone number verification code
   * @param {string} cancel_ticket - Ticket returned by cancel_check API
   * @param {string} abandon - A comma-separated string containing abandoned assets
   * @return {Promise} - result
   */


  this.confirm = function (params) {
    var value_ticket = params.value_ticket,
        token = params.token,
        cancel_ticket = params.cancel_ticket,
        abandon = params.abandon,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    return _this.request({
      url: WEB_URL.CANCEL_CONFIRM,
      method: 'POST',
      data: _extends({
        value_ticket: value_ticket,
        token: token,
        cancel_ticket: cancel_ticket,
        abandon: abandon
      }, extra_params)
    });
  };

  var request = props.request;
  this.request = request;
};

var OpenAPI = /*#__PURE__*/function () {
  function OpenAPI(props) {
    var request = props.request;
    this.request = request;
  }
  /**
   * [get auth info]
   * @param {string} client_key key of third-party app
   * @param {string} scope list of authorities
   * @return {Promise} request result
   */


  var _proto = OpenAPI.prototype;

  _proto.getAuthInfo = function getAuthInfo(params) {
    var client_key = params.client_key,
        scope = params.scope,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    return this.request({
      url: WEB_URL.GET_OPEN_AUTH_INFO,
      method: 'GET',
      data: _extends({
        client_key: client_key,
        scope: scope
      }, extra_params)
    });
  }
  /**
   * [send code]
   * @param {string} mobile - the mobile used to login
   * @return {Promise} send result
   */
  ;

  _proto.sendCode = function sendCode(params) {
    var mobile = params.mobile,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: 27
    }, extra_params), ['mobile', 'type']);
    return this.request({
      url: WEB_URL.OPEN_SEND_CODE,
      method: 'GET',
      data: data
    });
  }
  /**
   * [sms authorization]
   * @param {string} client_key key of third-party app
   * @param {string} scope list of authorities
   * @param {string} source source of authorization
   * @param {string} redirect_uri redirect url after successful authorization
   * @param {string} state security check
   * @param {string} mobile mobile used to authorize
   * @param {string} code corresponding sms code
   * @return {Promise} auth result
   */
  ;

  _proto.smsAuth = function smsAuth(params) {
    var client_key = params.client_key,
        scope = params.scope,
        source = params.source,
        redirect_uri = params.redirect_uri,
        state = params.state,
        mobile = params.mobile,
        code = params.code,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      client_key: client_key,
      scope: scope,
      source: source,
      redirect_uri: redirect_uri,
      state: state,
      mobile: mobile,
      code: code
    }, extra_params), ['mobile', 'code']);
    return this.request({
      url: WEB_URL.OPEN_SMS_AUTH,
      method: 'POST',
      data: data
    });
  }
  /**
   * [sms authorization]
   * @param {string} client_key key of third-party app
   * @param {string} scope list of authorities
   * @param {string} source source of authorization
   * @param {string} redirect_uri redirect url after successful authorization
   * @param {string} state security check
   * @param {string} mobile mobile used to authorize
   * @param {string} code corresponding sms code
   * @return {Promise} auth result
   */
  ;

  _proto.accountAuth = function accountAuth(params) {
    var client_key = params.client_key,
        scope = params.scope,
        source = params.source,
        redirect_uri = params.redirect_uri,
        state = params.state,
        password = params.password,
        account = params.account,
        _params$extra_params4 = params.extra_params,
        extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      client_key: client_key,
      scope: scope,
      source: source,
      redirect_uri: redirect_uri,
      state: state,
      password: password,
      account: account
    }, extra_params), ['password', 'account']);
    return this.request({
      url: WEB_URL.OPEN_ACCOUNT_AUTH,
      method: 'POST',
      data: data
    });
  };

  return OpenAPI;
}();

var AccountAPI = function AccountAPI(props) {
  var _this = this;

  /**
   * @return {Promise} request result
   */
  this.getAccountInfo = function (params) {
    if (params === void 0) {
      params = {};
    }

    var _params = params,
        _params$extra_params = _params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    return _this.request({
      url: WEB_URL.ACCOUNT_INFO,
      method: 'GET',
      data: extra_params
    });
  };

  var request = props.request;
  this.request = request;
};

var WebInterface = /*#__PURE__*/function (_BaseInterface) {
  _inheritsLoose(WebInterface, _BaseInterface);

  function WebInterface(props) {
    var _this;

    _this = _BaseInterface.call(this, props, 'web') || this;
    var _props$printLog = props.printLog,
        printLog = _props$printLog === void 0 ? false : _props$printLog,
        _props$acrawler = props.acrawler,
        acrawler = _props$acrawler === void 0 ? '' : _props$acrawler; // log

    if (printLog) {
      console.log('%cWebInterface Initial Props >>>>%O', 'background: #222; color: #bada55', props);
    } // acrawler


    if (acrawler) {
      initAcrawler(acrawler, props);
    } // web interfaces


    var argus = _extends({}, props, {
      request: _this.request
    });

    _this.login = new LoginAPI$1(argus);
    _this.qrcodeLogin = new QrCodeLoginAPI(argus);
    _this.register = new RegisterAPI$1(argus);
    _this.forgetPwd = new ForgetPwdAPI$1(argus);
    _this.bind = new BindAPI(argus);
    _this.rebind = new RebindAPI(argus);
    _this.password = new PasswordAPI(argus);
    _this.extra = new ExtraAPI(argus);
    _this.verify = new VerifyAPI(argus);
    _this.cancel = new CancelAPI(argus);
    _this.open = new OpenAPI(argus);
    _this.account = new AccountAPI(argus); // web aff interfaces

    _this.affLogin = new LoginAPI(argus);
    _this.affRegister = new RegisterAPI(argus);
    _this.affInvite = new InviteAPI(argus);
    _this.affSubject = new SubjectAPI(argus);
    _this.affForgetPwd = new ForgetPwdAPI(argus);
    _this.affResource = new ResourceAPI(argus);
    _this.affRole = new RoleAPI(argus);
    _this.affUser = new UserAPI(argus);
    _this.affSuper = new SuperAPI(argus);
    return _this;
  }

  return WebInterface;
}(BaseInterface);

var VerifyAPI$1 = function VerifyAPI(props) {
  var _this = this;

  /**
   * @param {string} mobile - mobile to be verified
   * @return {Promise} - send result
   */
  this.notLoginSendCode = function (params) {
    var mobile = params.mobile,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: 34
    }, extra_params), ['mobile', 'type']);
    return _this.request({
      url: APP_URL.SEND_MOBILE_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} mobile - mobile to be verified
   * @param {string} code - the captcha
   * @return {Promise} - verify result
   */


  this.notLoginValidateMobile = function (params) {
    var mobile = params.mobile,
        code = params.code,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      type: 34
    }, extra_params), ['mobile', 'code', 'type']);
    return _this.request({
      url: APP_URL.CHECK_MOBILE_CODE,
      method: 'POST',
      data: data
    });
  };

  var request = props.request;
  this.request = request;
};

var AppInterface = /*#__PURE__*/function (_BaseInterface) {
  _inheritsLoose(AppInterface, _BaseInterface);

  function AppInterface(props) {
    var _this;

    _this = _BaseInterface.call(this, props, 'app') || this;
    var _props$printLog = props.printLog,
        printLog = _props$printLog === void 0 ? false : _props$printLog,
        _props$acrawler = props.acrawler,
        acrawler = _props$acrawler === void 0 ? '' : _props$acrawler; // log

    if (printLog) {
      console.log('AppInterface Initial Props >>>>', props);
    } // acrawler


    if (acrawler) {
      initAcrawler(acrawler, props);
    } // web interfaces


    var argus = _extends({}, props, {
      request: _this.request
    });

    _this.verify = new VerifyAPI$1(argus);
    return _this;
  }

  return AppInterface;
}(BaseInterface);

var CommonService = /*#__PURE__*/function () {
  function CommonService(props) {
    var request = props.request;
    this.request = request;
  }
  /**
   * [get mobile verification code] out-of-date
   * @param {string} mobile the mobile used to login
   * @param {number} type codeType
   * @return {Promise} send result
   */


  var _proto = CommonService.prototype;

  _proto.baseSendMobileCode = function baseSendMobileCode(params) {
    var _this = this;

    var mobile = params.mobile,
        type = params.type,
        extra_params = _objectWithoutPropertiesLoose(params, ["mobile", "type"]);

    var data = encryptParams(_extends({
      mobile: mobile,
      type: type
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_SSO.MOBILE_CODE_URL,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  }
  /**
   * [get mobile verification code V2]
   * @param {string} mobile the mobile used to login
   * @param {number} type codeType
   * @return {Promise} send result
   */
  ;

  _proto.baseSendMobileCodeV2 = function baseSendMobileCodeV2(params) {
    var _this2 = this;

    var mobile = params.mobile,
        type = params.type,
        extra_params = _objectWithoutPropertiesLoose(params, ["mobile", "type"]);

    var data = encryptParams(_extends({
      mobile: mobile,
      type: type
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this2.request({
        url: WEB_SSO.MOBILE_CODE_URL_V2,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  }
  /**
   * [send a verification url to email] out-of-date
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  ;

  _proto.baseSendEmailLink = function baseSendEmailLink(params) {
    var _this3 = this;

    var email = params.email,
        password = params.password,
        extra_params = _objectWithoutPropertiesLoose(params, ["email", "password"]);

    var data = encryptParams(_extends({
      email: email,
      password: password
    }, extra_params), ['email', 'password']);
    return new Promise(function (resolve, reject) {
      _this3.request({
        url: WEB_SSO.EMAIL_ACTIVATE_URL,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  }
  /**
   * [send a verification link to email v2]
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  ;

  _proto.baseSendEmailLinkV2 = function baseSendEmailLinkV2(params) {
    var _this4 = this;

    var email = params.email,
        password = params.password,
        extra_params = _objectWithoutPropertiesLoose(params, ["email", "password"]);

    var data = encryptParams(_extends({
      email: email,
      password: password
    }, extra_params), ['email', 'password']);
    return new Promise(function (resolve, reject) {
      _this4.request({
        url: WEB_SSO.EMAIL_ACTIVATE_URL_V2,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  }
  /**
   * [send a verification code to email] out-of-date
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  ;

  _proto.baseSendEmailCode = function baseSendEmailCode(params) {
    var _this5 = this;

    var email = params.email,
        password = params.password,
        extra_params = _objectWithoutPropertiesLoose(params, ["email", "password"]);

    var data = encryptParams(_extends({
      email: email,
      password: password
    }, extra_params), ['email', 'password']);
    return new Promise(function (resolve, reject) {
      _this5.request({
        url: WEB_SSO.EMAIL_ACTIVATE_CODE_URL,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  }
  /**
   * [send a verification code to email v2]
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  ;

  _proto.baseSendEmailCodeV2 = function baseSendEmailCodeV2(params) {
    var _this6 = this;

    var email = params.email,
        password = params.password,
        extra_params = _objectWithoutPropertiesLoose(params, ["email", "password"]);

    var data = encryptParams(_extends({
      email: email,
      password: password
    }, extra_params), ['email', 'password']);
    return new Promise(function (resolve, reject) {
      _this6.request({
        url: WEB_SSO.EMAIL_ACTIVATE_CODE_URL_V2,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  return CommonService;
}();

var BindMobileService = /*#__PURE__*/function (_CommonService) {
  _inheritsLoose(BindMobileService, _CommonService);

  function BindMobileService() {
    return _CommonService.apply(this, arguments) || this;
  }

  var _proto = BindMobileService.prototype;

  /**
   * [get mobile verification code] out-of-date
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  _proto.sendMobileCode = function sendMobileCode(params) {
    return this.baseSendMobileCode(_extends({}, params, {
      type: 8
    }));
  }
  /**
   * [get mobile verification code V2]
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  ;

  _proto.sendMobileCodeV2 = function sendMobileCodeV2(params) {
    return this.baseSendMobileCodeV2(_extends({}, params, {
      type: 8
    }));
  }
  /**
   * [bind mobile]
   * @param {string} mobile mobile number
   * @param {string} code verify code
   * @param {number} unbind_exist
   */
  ;

  _proto.mobileBind = function mobileBind(params) {
    var _this = this;

    var mobile = params.mobile,
        code = params.code,
        extra_params = _objectWithoutPropertiesLoose(params, ["mobile", "code"]);

    var data = encryptParams(_extends({
      mobile: mobile,
      code: code
    }, extra_params, {
      type: 8
    }), ['mobile', 'type', 'code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_SSO.BIND_MOBILE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  return BindMobileService;
}(CommonService);

var ChangeMobileService = /*#__PURE__*/function (_CommonService) {
  _inheritsLoose(ChangeMobileService, _CommonService);

  function ChangeMobileService() {
    return _CommonService.apply(this, arguments) || this;
  }

  var _proto = ChangeMobileService.prototype;

  /**
   * [get mobile verification code] out-of-date
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  _proto.sendMobileCode = function sendMobileCode(params) {
    return this.baseSendMobileCode(_extends({}, params, {
      type: 20
    }));
  }
  /**
   * [get mobile verification code V2]
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  ;

  _proto.sendMobileCodeV2 = function sendMobileCodeV2(params) {
    return this.baseSendMobileCodeV2(_extends({}, params, {
      type: 20
    }));
  }
  /**
   * [update bind mobile number]
   * @param {string} mobile new mobile
   * @param {string} code verifyCode
   */
  ;

  _proto.mobileChange = function mobileChange(params) {
    var _this = this;

    var mobile = params.mobile,
        code = params.code,
        extra_params = _objectWithoutPropertiesLoose(params, ["mobile", "code"]);

    var data = encryptParams(_extends({
      mobile: mobile,
      code: code
    }, extra_params), ['mobile', 'code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_SSO.CHANGE_MOBILE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  return ChangeMobileService;
}(CommonService);

var LoginService = /*#__PURE__*/function (_CommonService) {
  _inheritsLoose(LoginService, _CommonService);

  function LoginService(props) {
    var _this;

    _this = _CommonService.call(this, props) || this;
    var host = props.host,
        originHost = props.originHost,
        aid = props.aid;
    _this.aid = aid;
    _this.host = host;
    _this.originHost = originHost;
    return _this;
  }
  /**
   * [check login status]
   * @param {string} service redirect url after login success
   * @return {Promise} login result
   */


  var _proto = LoginService.prototype;

  _proto.checkLogin = function checkLogin(params) {
    return this.request({
      url: WEB_SSO.CHECK_LOGIN,
      method: 'GET',
      data: _extends({}, params)
    });
  } // /**
  //  * [get mobile verification code] out-of-date
  //  * @param {string} mobile the mobile used to login
  //  * @return {Promise} send result
  //  */
  // public sendMobileCode(params: { mobile: string }): Promise<any> {
  //   return this.baseSendMobileCode({
  //     ...params,
  //     type: 24,
  //   });
  // }

  /**
   * [get mobile verification code V2]
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  ;

  _proto.sendMobileCodeV2 = function sendMobileCodeV2(params) {
    return this.baseSendMobileCodeV2(_extends({}, params, {
      type: 24
    }));
  } // /**
  //  * [quick authentication] out-of-date
  //  * @param {string} mobile the mobile used to login
  //  * @param {number} service redirect url after login success
  //  * @return {Promise} send result
  //  */
  // public quickAuth(params: { service: string; mobile: string }): Promise<any> {
  //   let { mobile, ...extra_params } = params;
  //   const data = encryptParams({ mobile, ...extra_params }, ['mobile']);
  //   return new Promise((resolve, reject) => {
  //     this.request({
  //       url: WEB_SSO.MOBILE_CODE_LOGIN_URL,
  //       method: 'POST',
  //       data,
  //     })
  //       .then((data: any) => {
  //         resolve(data);
  //       })
  //       .catch((e: any) => {
  //         reject(e);
  //       });
  //   });
  // }

  /**
   * [quick authentication V2]
   * @param {string} mobile the mobile used to login
   * @param {string} code corresponding code
   * @param {number} service redirect url after login success
   * @return {Promise} send result
   */
  ;

  _proto.quickAuthV2 = function quickAuthV2(params) {
    var mobile = params.mobile,
        code = params.code,
        extra_params = _objectWithoutPropertiesLoose(params, ["mobile", "code"]);

    var data = encryptParams(_extends({
      mobile: mobile,
      code: code
    }, extra_params), ['mobile', 'code']);
    return this.request({
      url: WEB_SSO.MOBILE_CODE_LOGIN_URL_V2,
      method: 'POST',
      data: data
    });
  } // /**
  //  * [login by account] out-of-date
  //  * @param {string} account account
  //  * @param {string} password password
  //  */
  // public accountLogin(params: { account: string; password: string }) {
  //   let { account, password, ...extra_params } = params;
  //   const data = encryptParams({ account, password, ...extra_params }, [
  //     'account',
  //     'password',
  //   ]);
  //   return new Promise((resolve, reject) => {
  //     this.request({
  //       url: WEB_SSO.ACCOUNT_LOGIN_URL,
  //       method: 'POST',
  //       data,
  //     })
  //       .then((data: any) => {
  //         resolve(data);
  //       })
  //       .catch((e: any) => {
  //         reject(e);
  //       });
  //   });
  // }

  /**
   * [login by account V2]
   * @param {string} account account
   * @param {string} password password
   * @param {string} service redirect url after successful login
   */
  ;

  _proto.accountLoginV2 = function accountLoginV2(params) {
    var account = params.account,
        password = params.password,
        service = params.service,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      account: account,
      password: password,
      service: service
    }, extra_params), ['account', 'password']);
    return this.request({
      url: WEB_SSO.ACCOUNT_LOGIN_URL_V2,
      method: 'POST',
      data: data
    });
  }
  /**
   * [logout]
   * @param {string} service redirect url after login success
   */
  ;

  _proto.logout = function logout(params) {
    var service = params.service;
    window.location.href = "" + this.host + WEB_SSO.LOGOUT + "?service=" + service;
  }
  /**
   * [wap login]
   * @param {string} origin request domain, this interface isn't sso
   * @param {string} platform_app_id the thrid appId
   * @param {string} next rederict url
   * @param {string} type default 'sso'
   * @param {string} use_local_host default 1
   * @param {string} scopes default 'user_info'
   * @param {string} url_params
   */
  ;

  _proto.wapLogin = function wapLogin(params) {
    var _params$origin = params.origin,
        origin = _params$origin === void 0 ? '' : _params$origin,
        _params$type = params.type,
        type = _params$type === void 0 ? 'sso' : _params$type,
        use_local_host = params.use_local_host,
        _params$scopes = params.scopes,
        scopes = _params$scopes === void 0 ? 'user_info' : _params$scopes,
        next = params.next,
        _params$url_params = params.url_params,
        url_params = _params$url_params === void 0 ? '' : _params$url_params,
        platform_app_id = params.platform_app_id,
        _params$platform = params.platform,
        platform = _params$platform === void 0 ? '' : _params$platform,
        _params$replace = params.replace,
        replace = _params$replace === void 0 ? false : _params$replace;
    var service = encodeURIComponent(next);
    var realNext = encodeURIComponent(this.host + '/auth/login_success/?service=' + service);
    var paramMap = {
      aid: this.aid,
      type: type,
      // 历史业务不推荐使用该参数，新业务可以使用，改为由业务自行传入
      use_local_host: use_local_host,
      scopes: scopes,
      next: realNext,
      url_params: url_params,
      platform_app_id: platform_app_id,
      platform: platform
    };
    var query = '';
    var len = Object.keys(paramMap).length;
    Object.keys(paramMap).forEach(function (key, index) {
      if (len === index + 1) {
        query += key + "=" + paramMap[key];
      } else {
        query += key + "=" + paramMap[key] + "&";
      }
    });
    var redirectUrl = "" + origin + WEB_SSO.AUTH_LOGIN_URL + "?" + query; // open url in current window

    if (replace) {
      window.location.href = redirectUrl;
    } else {
      // TODO
      var childWindow = window.open(redirectUrl, '_blank');
    }
  }
  /**
   * [send a verification url to email] out-of-date
   * @param {string} email email
   * @param {string} next redirect url after login success
   */
  ;

  _proto.sendEmailLink = function sendEmailLink(params) {
    return this.baseSendEmailLink(_extends({}, params, {
      ect_type: 13
    }));
  }
  /**
   * [send a verification url to email V2]
   * @param {string} email email
   * @param {string} next redirect url after login success
   */
  ;

  _proto.sendEmailLinkV2 = function sendEmailLinkV2(params) {
    return this.baseSendEmailLinkV2(_extends({}, params, {
      ect_type: 13
    }));
  }
  /**
   * [send a verification code to email] out-of-date
   * @param {string} email email
   * @param {string} next redirect url after login success
   */
  ;

  _proto.sendEmailCode = function sendEmailCode(params) {
    return this.baseSendEmailCode(_extends({}, params, {
      ect_type: 13
    }));
  }
  /**
   * [send a verification code to email V2]
   * @param {string} email email
   * @param {string} next redirect url after login success
   */
  ;

  _proto.sendEmailCodeV2 = function sendEmailCodeV2(params) {
    return this.baseSendEmailCodeV2(_extends({}, params, {
      ect_type: 13
    }));
  }
  /**
   * [third party login with mobile]
   * @param {string} code authorization code
   * @param {string} profile_key user label
   * @param {number} platform_app_id the thrid appId
   * @param {number} change_bind whether rebind forcely when conflict occurs
   * @param {string} service redirect url after successful login
   */
  ;

  _proto.bindWithMobileLogin = function bindWithMobileLogin(params) {
    var code = params.code,
        platform_app_id = params.platform_app_id,
        service = params.service,
        profile_key = params.profile_key,
        _params$change_bind = params.change_bind,
        change_bind = _params$change_bind === void 0 ? 0 : _params$change_bind,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    return this.request({
      url: WEB_SSO.BIND_WITH_MOBILE_LOGIN,
      method: 'POST',
      data: _extends({
        code: code,
        platform_app_id: platform_app_id,
        service: service,
        profile_key: profile_key,
        change_bind: change_bind
      }, extra_params)
    });
  }
  /**
   * [third party login with mobile]
   * @param {string} code authorization code
   * @param {number} platform_app_id the thrid appId
   * @param {string} profile_key user label
   * @param {boolean} login_only - 'true' for only login, 'false' for register and login
   * @param {string} service redirect url after successful login
   */
  ;

  _proto.authLogin = function authLogin(params) {
    var code = params.code,
        platform_app_id = params.platform_app_id,
        service = params.service,
        profile_key = params.profile_key,
        _params$login_only = params.login_only,
        login_only = _params$login_only === void 0 ? false : _params$login_only,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    return this.request({
      url: login_only ? WEB_SSO.AUTH_LOGIN_ONLY : WEB_SSO.AUTH_LOGIN,
      method: 'POST',
      data: _extends({
        code: code,
        platform_app_id: platform_app_id,
        service: service,
        profile_key: profile_key
      }, extra_params)
    });
  };

  return LoginService;
}(CommonService);

var PasswordService = /*#__PURE__*/function (_CommonService) {
  _inheritsLoose(PasswordService, _CommonService);

  function PasswordService() {
    return _CommonService.apply(this, arguments) || this;
  }

  var _proto = PasswordService.prototype;

  // /**
  //  * [get mobile verification code] out-of-date
  //  * @param {string} mobile the mobile used to login
  //  * @return {Promise} send result
  //  */
  // public sendMobileCode(params: { mobile: string }): Promise<any> {
  //   return this.baseSendMobileCode({
  //     ...params,
  //     type: 6,
  //   });
  // }

  /**
   * [get mobile verification code V2]
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  _proto.sendMobileCodeV2 = function sendMobileCodeV2(params) {
    return this.baseSendMobileCodeV2(_extends({}, params, {
      type: 6
    }));
  } // /**
  //  * [send a verification url to email] out-of-date
  //  * @param {string} email email
  //  * @param {string} next redirect url after login success
  //  * @param {string} password password
  //  */
  // public sendEmailCode(params: {
  //   email: string;
  //   next?: string;
  //   password?: string;
  // }): Promise<any> {
  //   let { email, password, ...extra_params } = params;
  //   const data = encryptParams(
  //     { email, password, ect_type: 4, ...extra_params },
  //     ['email', 'password']
  //   );
  //   return new Promise((resolve, reject) => {
  //     this.request({
  //       url: WEB_SSO.SSO_EMAIL_ACTIVATE_CODE_URL,
  //       method: 'POST',
  //       data,
  //     })
  //       .then((data: any) => {
  //         resolve(data);
  //       })
  //       .catch((e: any) => {
  //         reject(e);
  //       });
  //   });
  // }

  /**
   * [send a verification url to email V2]
   * @param {string} email email
   * @param {string} next redirect url after login success
   * @param {string} password password
   */
  ;

  _proto.sendEmailCodeV2 = function sendEmailCodeV2(params) {
    return this.baseSendEmailCodeV2(_extends({}, params, {
      ect_type: 4
    }));
  }
  /**
   * [reset password]
   * @param {string} account account
   * @param {string} code verify code
   * @param {string} password new password
   */
  ;

  _proto.resetPassword = function resetPassword(params) {
    var _this = this;

    var account = params.account,
        code = params.code,
        password = params.password;
    var data = encryptParams({
      account: account,
      code: code,
      password: password
    }, ['account', 'code', 'password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_SSO.RESET_PASSWORD,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  return PasswordService;
}(CommonService);

var QrCodeService = /*#__PURE__*/function (_CommonService) {
  _inheritsLoose(QrCodeService, _CommonService);

  function QrCodeService() {
    return _CommonService.apply(this, arguments) || this;
  }

  var _proto = QrCodeService.prototype;

  /**
   * [get qrcode url]
   * @param {string} service redirect url after login success
   */
  _proto.getQrcode = function getQrcode(params) {
    var service = params.service,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    return this.request({
      // WARNING: axios会encodeURL相关参数，原因未知，暂时这么处理
      url: WEB_SSO.GET_QRCODE + "?service=" + encodeURIComponent(service),
      method: 'GET',
      data: extra_params
    });
  }
  /**
   * [query qrCode status]
   * @param {string} service redirect url after login success
   * @param {string} token result of GetQrcode
   */
  ;

  _proto.checkQrconnect = function checkQrconnect(params) {
    var service = params.service,
        token = params.token,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    return this.request({
      // WARNING: axios会encodeURL相关参数，原因未知，暂时这么处理
      url: WEB_SSO.CHECK_QRCONNECT + "?service=" + encodeURIComponent(service),
      method: 'GET',
      data: _extends({
        // service,
        token: token
      }, extra_params)
    });
  };

  return QrCodeService;
}(CommonService);

var QuickAuthService = /*#__PURE__*/function (_CommonService) {
  _inheritsLoose(QuickAuthService, _CommonService);

  function QuickAuthService() {
    return _CommonService.apply(this, arguments) || this;
  }

  var _proto = QuickAuthService.prototype;

  /**
   * [get mobile verification code] out-of-date
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  _proto.sendMobileCode = function sendMobileCode(params) {
    return this.baseSendMobileCode(_extends({}, params, {
      type: 22
    }));
  }
  /**
   * [get mobile verification code V2]
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  ;

  _proto.sendMobileCodeV2 = function sendMobileCodeV2(params) {
    return this.baseSendMobileCodeV2(_extends({}, params, {
      type: 22
    }));
  }
  /**
   * [quick auth by mobile]
   * @param {string} service redirect url after login success
   * @param {string} code mobile verify code
   */
  ;

  _proto.quickAuth = function quickAuth(params) {
    var _this = this;

    var code = params.code,
        extra_params = _objectWithoutPropertiesLoose(params, ["code"]);

    var data = encryptParams(_extends({
      code: code
    }, extra_params), ['code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_SSO.QUICK_AUTH,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };

  return QuickAuthService;
}(CommonService);

var RegisterService = /*#__PURE__*/function (_CommonService) {
  _inheritsLoose(RegisterService, _CommonService);

  function RegisterService() {
    return _CommonService.apply(this, arguments) || this;
  }

  var _proto = RegisterService.prototype;

  /**
   * [email register xhr]
   * @param {string} params -- requeset body data
   */
  _proto.emailRegisterXhr = function emailRegisterXhr(params) {
    return this.request({
      url: WEB_SSO.EMAIL_REGISTER,
      method: 'POST',
      data: params
    });
  }
  /**
   * [email register]
   * @param {string} email email
   * @param {string} next redirect url after successful registration
   * @param {string} code code
   * @param {string} token token in email verification link
   * @param {string} password account password
   * @param {string} email_logic_type const
   */
  ;

  _proto.emailRegister = function emailRegister(params) {
    var email = params.email,
        extra_params = _objectWithoutPropertiesLoose(params, ["email"]);

    var data = encryptParams(_extends({
      email: email
    }, extra_params, {
      ect_type: 1
    }), ['email', 'code', 'password']);
    return this.emailRegisterXhr(data);
  } // /**
  //  * [email register and bind mobile] out-of-date
  //  * @param {string} email email
  //  * @param {string} code code
  //  * @param {string} mobile mobile
  //  * @param {string} password password
  //  */
  // public emailRegisterAndBindMoblie(params: {
  //   email?: string;
  //   code: string;
  //   mobile: string;
  //   password: string;
  // }) {
  //   let { email, code, mobile, password, ...extra_params } = params;
  //   const data = encryptParams(
  //     { email, code, mobile, password, ...extra_params },
  //     ['email', 'code', 'mobile', 'password']
  //   );
  //   return this.emailRegisterXhr(data);
  // }

  /**
   * [email register and bind mobile V2]
   * @param {string} email email
   * @param {string} code code
   * @param {string} mobile mobile
   * @param {string} password password
   */
  ;

  _proto.emailRegisterAndBindMoblieV2 = function emailRegisterAndBindMoblieV2(params) {
    var _this = this;

    var email = params.email,
        code = params.code,
        mobile = params.mobile,
        password = params.password,
        extra_params = _objectWithoutPropertiesLoose(params, ["email", "code", "mobile", "password"]);

    var data = encryptParams(_extends({
      email: email,
      code: code,
      mobile: mobile,
      password: password
    }, extra_params), ['email', 'code', 'mobile', 'password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_SSO.EMAIL_REGISTER_V2,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  }
  /**
   * [mobile register and bind email V2]
   * @param {string} email email
   * @param {string} code code
   * @param {string} mobile mobile
   * @param {string} password password
   */
  ;

  _proto.mobileRegisterAndBindEmailV2 = function mobileRegisterAndBindEmailV2(params) {
    var email = params.email,
        code = params.code,
        mobile = params.mobile,
        password = params.password,
        extra_params = _objectWithoutPropertiesLoose(params, ["email", "code", "mobile", "password"]);

    var data = encryptParams(_extends({
      email: email,
      code: code,
      mobile: mobile,
      password: password
    }, extra_params), ['email', 'code', 'mobile', 'password']);
    return this.request({
      url: WEB_SSO.MOBILE_REGISTER_WITH_EMAIL,
      method: 'POST',
      data: data
    });
  }
  /**
   * [login by email code]
   * @param {string} email email
   * @param {string} next redierct url
   * @param {string} code verify code
   * @param {string} token verify token
   */
  ;

  _proto.emailActivateCodeLogin = function emailActivateCodeLogin(params) {
    var _this2 = this;

    var email = params.email,
        code = params.code,
        extra_params = _objectWithoutPropertiesLoose(params, ["email", "code"]);

    var data = encryptParams(_extends({
      email: email,
      code: code
    }, extra_params, {
      ect_type: 13
    }), ['email', 'code']);
    return new Promise(function (resolve, reject) {
      _this2.request({
        url: WEB_SSO.EMAIL_ACTIVATE_CODE_LOGIN,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  }
  /**
   * [get mobile verification code] out-of-date
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  ;

  _proto.sendMobileCode = function sendMobileCode(params) {
    return this.baseSendMobileCode(_extends({}, params, {
      type: 16
    }));
  }
  /**
   * [get mobile verification code V2]
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  ;

  _proto.sendMobileCodeV2 = function sendMobileCodeV2(params) {
    return this.baseSendMobileCodeV2(_extends({}, params, {
      type: 16
    }));
  }
  /**
   * [send a verification url to email] out-of-date
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  ;

  _proto.sendEmailLink = function sendEmailLink(params) {
    return this.baseSendEmailLink(_extends({}, params, {
      ect_type: 1
    }));
  }
  /**
   * [send a verification url to email V2]
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  ;

  _proto.sendEmailLinkV2 = function sendEmailLinkV2(params) {
    return this.baseSendEmailLinkV2(_extends({}, params, {
      ect_type: 1
    }));
  }
  /**
   * [send a verification code to email] out-of-date
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  ;

  _proto.sendEmailCode = function sendEmailCode(params) {
    return this.baseSendEmailCode(_extends({}, params, {
      ect_type: 1
    }));
  }
  /**
   * [send a verification code to email V2]
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  ;

  _proto.sendEmailCodeV2 = function sendEmailCodeV2(params) {
    return this.baseSendEmailCodeV2(_extends({}, params, {
      ect_type: 1
    }));
  };

  return RegisterService;
}(CommonService);

var SsoInterface = /*#__PURE__*/function (_BaseInterface) {
  _inheritsLoose(SsoInterface, _BaseInterface);

  function SsoInterface(props) {
    var _this;

    _this = _BaseInterface.call(this, props, 'sso') || this;
    var host = props.host,
        printLog = props.printLog; // log

    if (printLog) {
      console.log('%cSSOInterface Initial Props >>>>%O', 'background: #222; color: #bada55', props);
    } // SSO address


    _this.host = host || ''; // domain address

    _this.originHost = window.location.origin;

    var argus = _extends({}, props, {
      request: _this.request
    });

    _this.bindMobile = new BindMobileService(argus);
    _this.changeMobile = new ChangeMobileService(argus);
    _this.login = new LoginService(_extends({}, argus, {
      originHost: _this.originHost
    }));
    _this.password = new PasswordService(argus);
    _this.qrcodeLogin = new QrCodeService(argus);
    _this.quickAuth = new QuickAuthService(argus);
    _this.register = new RegisterService(argus);
    return _this;
  }

  return SsoInterface;
}(BaseInterface);

var WebInterfaceSdk = WebInterface;
var AppInterfaceSdk = AppInterface;
var SsoInterfaceSdk = SsoInterface;

var AccountSdk = function AccountSdk(props) {
  var _props$scope = props.scope,
      scope = _props$scope === void 0 ? 'web' : _props$scope;

  switch (scope) {
    case 'web':
      {
        return new WebInterface(props);
      }

    case 'app':
      {
        return new AppInterface(props);
      }

    case 'sso':
      {
        return new SsoInterface(props);
      }

    default:
      {
        return new WebInterface(props);
      }
  }
};

var SdkType = {
  web: WebInterface,
  app: AppInterface,
  sso: SsoInterface
};
var SdkInstance = {
  web: null,
  app: null,
  sso: null
};

var AccountSdkFactory = /*#__PURE__*/function () {
  function AccountSdkFactory() {}

  AccountSdkFactory.createAccountSdk = function createAccountSdk(type, config) {
    var targetType = SdkType[type] || SdkType['web'];

    if (SdkInstance[type]) {
      return SdkInstance[type];
    }

    SdkInstance[type] = AccountSdkFactory.create(targetType, config);
    return SdkInstance[type];
  };

  AccountSdkFactory.create = function create(Type, config) {
    return new Type(config);
  };

  return AccountSdkFactory;
}();

var createAccountSdk = AccountSdkFactory.createAccountSdk;
var AccountSdkInstance = createAccountSdk;

export default AccountSdk;
export { AccountSdkInstance, AppInterfaceSdk, SsoInterfaceSdk, WebInterfaceSdk };
//# sourceMappingURL=account-api.esm.js.map
